const translate = {
  header_action_menu: {
    archive_all_items: {
      en: 'Archive All Items',
      es: 'Archivar Todos los Artículos',
      fr: 'Archiver Tous les Articles',
      de: 'Alle Artikel Archivieren',
      pt: 'Arquivar Todos os Itens',
      pl: 'Archiwizuj Wszystkie Przedmioty',
      nl: 'Alle Items Archiveren',
      el: 'Αρχειοθέτηση Όλων των Αντικειμένων',
      cs: 'Archivovat Všechny Položky',
      sv: 'Arkivera Alla Objekt',
      hu: 'Összes Elem Archiválása',
      da: 'Arkiver Alle Elementer',
      fi: 'Arkistoi Kaikki Kohteet',
      sk: 'Archivovať Všetky Položky',
      bg: 'Архивиране на Всички Елементи',
      hr: 'Arhiviraj Sve Stavke',
      lt: 'Archyvuoti Visus Elementus',
      lv: 'Arhivēt Visus Vienumus',
      et: 'Arhiveeri Kõik Üksused',
      sl: 'Arhiviraj Vse Postavke',
      ga: 'Cartlannaigh Gach Mír',
      mt: 'Arkivja l-Oġġetti Kollha',
      cy: 'Archifo Pob Eitem',
      ro: 'Arhivează Toate Elementele',
      it: 'Archivia Tutti gli Elementi',
      zh_cn: '归档所有项目',
      hi: 'सभी आइटम संग्रहित करें',
      ar: 'أرشفة جميع العناصر',
      bn: 'সমস্ত আইটেম সংরক্ষণ করুন',
      ru: 'Архивировать Все Элементы',
      ja: 'すべてのアイテムをアーカイブ',
      tr: 'Tüm Öğeleri Arşivle',
      ko: '모든 항목 아카이브',
      vi: 'Lưu Trữ Tất Cả Mục',
      id: 'Arsipkan Semua Item',
      th: 'เก็บถาวรทุกรายการ',
      ms: 'Arkibkan Semua Item',
      ar_eg: 'أرشفة جميع العناصر',
      uk: 'Архівувати Усі Елементи',
    },
    move_items: {
      en: 'Move Items',
      es: 'Mover Artículos',
      fr: 'Déplacer les Articles',
      de: 'Artikel Verschieben',
      pt: 'Mover Itens',
      pl: 'Przenieś Przedmioty',
      nl: 'Items Verplaatsen',
      el: 'Μετακίνηση Αντικειμένων',
      cs: 'Přesunout Položky',
      sv: 'Flytta Artiklar',
      hu: 'Elemek Áthelyezése',
      da: 'Flyt Varer',
      fi: 'Siirrä Kohteet',
      sk: 'Presunúť Položky',
      bg: 'Преместване на Артикули',
      hr: 'Premjesti Stavke',
      lt: 'Perkelti Prekes',
      lv: 'Pārvietot Vienumus',
      et: 'Liiguta Üksusi',
      sl: 'Premakni Postavke',
      ga: 'Bog Míreanna',
      mt: 'Mexxi Oġġetti',
      cy: 'Symud Eitemau',
      ro: 'Mută Articolele',
      it: 'Sposta gli Articoli',
      zh_cn: '移动项目',
      hi: 'आइटम स्थानांतरित करें',
      ar: 'نقل العناصر',
      bn: 'আইটেম সরান',
      ru: 'Переместить Элементы',
      ja: 'アイテムを移動',
      tr: 'Öğeleri Taşı',
      ko: '항목 이동',
      vi: 'Di Chuyển Các Mặt Hàng',
      id: 'Pindahkan Barang',
      th: 'ย้ายสินค้า',
      ms: 'Pindah Item',
      ar_eg: 'نقل العناصر',
      uk: 'Перемістити Предмети',
    },
  },
  row_action_menu: {
    edit_availability: {
      en: 'Edit Availability',
      es: 'Editar Disponibilidad',
      fr: 'Modifier la Disponibilité',
      de: 'Verfügbarkeit Bearbeiten',
      pt: 'Editar Disponibilidade',
      pl: 'Edytuj Dostępność',
      nl: 'Beschikbaarheid Bewerken',
      el: 'Επεξεργασία Διαθεσιμότητας',
      cs: 'Upravit Dostupnost',
      sv: 'Redigera Tillgänglighet',
      hu: 'Elérhetőség Szerkesztése',
      da: 'Rediger Tilgængelighed',
      fi: 'Muokkaa Saatavuutta',
      sk: 'Upraviť Dostupnosť',
      bg: 'Редактиране на Наличност',
      hr: 'Uredi Dostupnost',
      lt: 'Redaguoti Prieinamumą',
      lv: 'Rediģēt Pieejamību',
      et: 'Muuda Saadavust',
      sl: 'Uredi Dostopnost',
      ga: 'Cuir in Eagar Infhaighteacht',
      mt: 'Editja l-Disponibilità',
      cy: 'Golygu Argaeledd',
      ro: 'Editează Disponibilitatea',
      it: 'Modifica la Disponibilità',
      zh_cn: '编辑可用性',
      hi: 'उपलब्धता संपादित करें',
      ar: 'تحرير التوفر',
      bn: 'প্রাপ্যতা সম্পাদনা করুন',
      ru: 'Редактировать Доступность',
      ja: '可用性を編集',
      tr: 'Mevcudiyeti Düzenle',
      ko: '가용성 편집',
      vi: 'Chỉnh Sửa Khả Dụng',
      id: 'Edit Ketersediaan',
      th: 'แก้ไขความพร้อมใช้งาน',
      ms: 'Edit Ketersediaan',
      ar_eg: 'تحرير التوفر',
      uk: 'Редагувати Доступність',
    },
    duplicate_item: {
      en: 'Duplicate Item',
      es: 'Duplicar Artículo',
      fr: "Dupliquer l'Article",
      de: 'Artikel Duplizieren',
      pt: 'Duplicar Item',
      pl: 'Duplikat Przedmiotu',
      nl: 'Item Dupliceren',
      el: 'Αντιγραφή Στοιχείου',
      cs: 'Duplikovat Položku',
      sv: 'Duplicera Artikel',
      hu: 'Elem Másolása',
      da: 'Kopiér Vare',
      fi: 'Kahdenna Kohde',
      sk: 'Duplikovať Položku',
      bg: 'Дублиране на Артикул',
      hr: 'Dupliciraj Stavku',
      lt: 'Dubliuoti Prekę',
      lv: 'Dublēt Vienumu',
      et: 'Dubleeri Üksust',
      sl: 'Podvoji Element',
      ga: 'Dúbláil Mír',
      mt: 'Duplika l-Oġġett',
      cy: 'Dyblygu Eitem',
      ro: 'Duplică Articolul',
      it: "Duplica l'Articolo",
      zh_cn: '复制项目',
      hi: 'आइटम की नकल करें',
      ar: 'تكرار العنصر',
      bn: 'আইটেম ডুপ্লিকেট করুন',
      ru: 'Дублировать Элемент',
      ja: 'アイテムを複製',
      tr: 'Öğeyi Kopyala',
      ko: '항목 복제',
      vi: 'Nhân Bản Mặt Hàng',
      id: 'Gandakan Barang',
      th: 'ทำซ้ำสินค้า',
      ms: 'Duplikat Item',
      ar_eg: 'تكرار العنصر',
      uk: 'Дублювати Елемент',
    },
    archive_item: {
      en: 'Archive Item',
      es: 'Archivar Artículo',
      fr: "Archiver l'Article",
      de: 'Artikel Archivieren',
      pt: 'Arquivar Item',
      pl: 'Zarchiwizuj Przedmiot',
      nl: 'Item Archiveren',
      el: 'Αρχειοθέτηση Στοιχείου',
      cs: 'Archivovat Položku',
      sv: 'Arkivera Artikel',
      hu: 'Elem Archiválása',
      da: 'Arkiver Vare',
      fi: 'Arkistoi Kohde',
      sk: 'Archivovať Položku',
      bg: 'Архивиране на Артикул',
      hr: 'Arhiviraj Stavku',
      lt: 'Archyvuoti Prekę',
      lv: 'Arhivēt Vienumu',
      et: 'Arhiveeri Üksus',
      sl: 'Arhiviraj Element',
      ga: 'Cartlann Mír',
      mt: 'Arkivja l-Oġġett',
      cy: 'Archifo Eitem',
      ro: 'Arhivează Articolul',
      it: "Archivia l'Articolo",
      zh_cn: '归档项目',
      hi: 'आइटम संग्रहित करें',
      ar: 'أرشفة العنصر',
      bn: 'আইটেম আর্কাইভ করুন',
      ru: 'Архивировать Элемент',
      ja: 'アイテムをアーカイブ',
      tr: 'Öğeyi Arşivle',
      ko: '항목 아카이브',
      vi: 'Lưu Trữ Mặt Hàng',
      id: 'Arsipkan Barang',
      th: 'เก็บถาวรสินค้า',
      ms: 'Arkibkan Item',
      ar_eg: 'أرشفة العنصر',
      uk: 'Архівувати Елемент',
    },
    move_item: {
      en: 'Move Item',
      es: 'Mover Artículo',
      fr: "Déplacer l'Article",
      de: 'Artikel Verschieben',
      pt: 'Mover Item',
      pl: 'Przenieś Przedmiot',
      nl: 'Item Verplaatsen',
      el: 'Μετακίνηση Στοιχείου',
      cs: 'Přesunout Položku',
      sv: 'Flytta Artikel',
      hu: 'Elem Áthelyezése',
      da: 'Flyt Vare',
      fi: 'Siirrä Kohde',
      sk: 'Presunúť Položku',
      bg: 'Преместване на Артикул',
      hr: 'Premjesti Stavku',
      lt: 'Perkelti Prekę',
      lv: 'Pārvietot Vienumu',
      et: 'Liiguta Üksust',
      sl: 'Premakni Element',
      ga: 'Bog Mír',
      mt: 'Mexxi l-Oġġett',
      cy: 'Symud Eitem',
      ro: 'Mută Articolul',
      it: "Sposta l'Articolo",
      zh_cn: '移动项目',
      hi: 'आइटम स्थानांतरित करें',
      ar: 'نقل العنصر',
      bn: 'আইটেম সরান',
      ru: 'Переместить Элемент',
      ja: 'アイテムを移動',
      tr: 'Öğeyi Taşı',
      ko: '항목 이동',
      vi: 'Di Chuyển Mặt Hàng',
      id: 'Pindahkan Barang',
      th: 'ย้ายสินค้า',
      ms: 'Pindah Item',
      ar_eg: 'نقل العنصر',
      uk: 'Перемістити Предмет',
    },
  },
  category_action_menus: {
    archive_category: {
      en: 'Archive Category',
      es: 'Archivar Categoría',
      fr: 'Archiver la Catégorie',
      de: 'Kategorie Archivieren',
      pt: 'Arquivar Categoria',
      pl: 'Archiwizuj Kategorię',
      nl: 'Categorie Archiveren',
      el: 'Αρχειοθέτηση Κατηγορίας',
      cs: 'Archivovat Kategorii',
      sv: 'Arkivera Kategori',
      hu: 'Kategória Archiválása',
      da: 'Arkiver Kategori',
      fi: 'Arkistoi Kategoria',
      sk: 'Archivovať Kategóriu',
      bg: 'Архивиране на Категория',
      hr: 'Arhiviraj Kategoriju',
      lt: 'Archyvuoti Kategoriją',
      lv: 'Arhivēt Kategoriju',
      et: 'Arhiveeri Kategooria',
      sl: 'Arhiviraj Kategorijo',
      ga: 'Cartlann Catagóir',
      mt: 'Arkivja l-Kategorija',
      cy: 'Archifo Categori',
      ro: 'Arhivează Categoria',
      it: 'Archivia la Categoria',
      zh_cn: '归档类别',
      hi: 'श्रेणी संग्रहित करें',
      ar: 'أرشفة الفئة',
      bn: 'বিভাগ আর্কাইভ করুন',
      ru: 'Архивировать Категорию',
      ja: 'カテゴリをアーカイブ',
      tr: 'Kategoriyi Arşivle',
      ko: '카테고리 보관',
      vi: 'Lưu Trữ Danh Mục',
      id: 'Arsipkan Kategori',
      th: 'จัดเก็บหมวดหมู่',
      ms: 'Arkibkan Kategori',
      ar_eg: 'أرشفة الفئة',
      uk: 'Архівувати Категорію',
    },
  },
  notify: {
    edit_text: {
      en: 'Sorry, the action you’re trying to perform is restricted to administrators only. If you believe you should have access to this feature, please contact the system administrator for assistance.',
      es: 'Lo siento, la acción que está intentando realizar está restringida solo a los administradores. Si cree que debería tener acceso a esta función, comuníquese con el administrador del sistema para obtener ayuda.',
      fr: "Désolé, l'action que vous essayez d'effectuer est réservée aux administrateurs. Si vous pensez que vous devriez avoir accès à cette fonctionnalité, veuillez contacter l'administrateur du système pour obtenir de l'aide.",
      de: 'Entschuldigung, die Aktion, die Sie ausführen möchten, ist nur Administratoren vorbehalten. Wenn Sie der Meinung sind, dass Sie Zugriff auf diese Funktion haben sollten, wenden Sie sich bitte an den Systemadministrator, um Unterstützung zu erhalten.',
      pt: 'Desculpe, a ação que você está tentando realizar é restrita apenas aos administradores. Se você acredita que deve ter acesso a este recurso, entre em contato com o administrador do sistema para obter assistência.',
      pl: 'Przepraszamy, ale działanie, które próbujesz wykonać, jest zastrzeżone tylko dla administratorów. Jeśli uważasz, że powinieneś mieć dostęp do tej funkcji, skontaktuj się z administratorem systemu w celu uzyskania pomocy.',
      nl: 'Sorry, de actie die u probeert uit te voeren, is alleen voorbehouden aan beheerders. Als u denkt dat u toegang zou moeten hebben tot deze functie, neem dan contact op met de systeembeheerder voor hulp.',
      el: 'Συγγνώμη, η ενέργεια που προσπαθείτε να εκτελέσετε είναι περιορισμένη μόνο για τους διαχειριστές. Εάν πιστεύετε ότι θα έπρεπε να έχετε πρόσβαση σε αυτή τη δυνατότητα, επικοινωνήστε με τον διαχειριστή του συστήματος για βοήθεια.',
      cs: 'Omlouváme se, ale akce, kterou se pokoušíte provést, je omezena pouze na administrátory. Pokud si myslíte, že byste měli mít přístup k této funkci, obraťte se na správce systému.',
      sv: 'Tyvärr, åtgärden du försöker utföra är begränsad till endast administratörer. Om du tror att du borde ha tillgång till denna funktion, vänligen kontakta systemadministratören för hjälp.',
      hu: 'Sajnáljuk, az általad végrehajtani kívánt művelet csak rendszergazdák számára korlátozott. Ha úgy gondolod, hogy hozzá kellene férned ehhez a funkcióhoz, kérjük, fordulj a rendszergazdához segítségért.',
      da: 'Beklager, handlingen, du forsøger at udføre, er kun begrænset til administratorer. Hvis du mener, at du bør have adgang til denne funktion, bedes du kontakte systemadministratoren for assistance.',
      fi: 'Valitettavasti toiminto, jota yrität suorittaa, on rajoitettu vain ylläpitäjille. Jos uskot, että sinulla pitäisi olla pääsy tähän ominaisuuteen, ota yhteyttä järjestelmänvalvojaan saadaksesi apua.',
      sk: 'Ospravedlňujeme sa, ale akcia, ktorú sa pokúšate vykonať, je obmedzená iba na správcov. Ak si myslíte, že by ste mali mať prístup k tejto funkcii, kontaktujte správcu systému.',
      bg: 'Съжаляваме, действието, което се опитвате да извършите, е ограничено само за администратори. Ако смятате, че трябва да имате достъп до тази функция, моля, свържете се със системния администратор за помощ.',
      hr: 'Žao nam je, radnja koju pokušavate izvršiti ograničena je samo na administratore. Ako vjerujete da biste trebali imati pristup ovoj funkciji, obratite se administratoru sustava za pomoć.',
      lt: 'Atsiprašome, veiksmas, kurį bandote atlikti, yra skirtas tik administratoriams. Jei manote, kad turėtumėte turėti prieigą prie šios funkcijos, kreipkitės pagalbos į sistemos administratorių.',
      lv: 'Atvainojiet, darbība, kuru mēģināt veikt, ir ierobežota tikai administratoriem. Ja uzskatāt, ka jums vajadzētu būt pieejai šai funkcijai, lūdzu, sazinieties ar sistēmas administratoru, lai saņemtu palīdzību.',
      et: 'Vabandust, tegevus, mida proovite sooritada, on piiratud ainult administraatoritele. Kui usute, et peaksite sellele funktsioonile juurde pääsema, võtke abi saamiseks ühendust süsteemi administraatoriga.',
      sl: 'Opravičujemo se, dejanje, ki ga poskušate izvesti, je omejeno samo na skrbnike. Če menite, da bi morali imeti dostop do te funkcije, se obrnite na skrbnika sistema za pomoč.',
      ga: 'Tá brón orainn, tá an gníomh atá tú ag iarraidh a dhéanamh srianta do riarthóirí amháin. Má chreideann tú gur chóir go mbeadh rochtain agat ar an ngné seo, déan teagmháil leis an riarthóir córais le do thoil chun cúnamh a fháil.',
      mt: 'Jiddispjaċina, l-azzjoni li qed tipprova twettaq hija ristretta għal amministraturi biss. Jekk temmen li għandek ikollok aċċess għal din il-karatteristika, jekk jogħġbok ikkuntattja lill-amministratur tas-sistema għall-għajnuna.',
      cy: 'Mae’n ddrwg gennym, mae’r weithred rydych yn ceisio’i chyflawni wedi’i chyfyngu i weinyddwyr yn unig. Os credwch y dylech gael mynediad i’r nodwedd hon, cysylltwch â gweinyddwr y system am gymorth.',
      ro: 'Ne pare rău, acțiunea pe care încercați să o efectuați este restricționată doar pentru administratori. Dacă credeți că ar trebui să aveți acces la această funcție, vă rugăm să contactați administratorul de sistem pentru asistență.',
      it: "Spiacenti, l'azione che stai cercando di eseguire è riservata solo agli amministratori. Se ritieni di dover avere accesso a questa funzionalità, contatta l'amministratore di sistema per assistenza.",
      zh_cn: '对不起，您尝试执行的操作仅限于管理员。如果您认为您应该有权访问此功能，请联系系统管理员以获取帮助。',
      hi: 'माफ़ करें, जिस क्रिया को आप निष्पादित करने का प्रयास कर रहे हैं वह केवल प्रशासकों के लिए प्रतिबंधित है। यदि आपको लगता है कि आपको इस सुविधा का उपयोग करने की अनुमति होनी चाहिए, तो कृपया सहायता के लिए सिस्टम व्यवस्थापक से संपर्क करें।',
      ar: 'عذرًا، الإجراء الذي تحاول تنفيذه مقصور على المسؤولين فقط. إذا كنت تعتقد أنه يجب أن يكون لديك حق الوصول إلى هذه الميزة، يرجى الاتصال بمسؤول النظام للحصول على المساعدة.',
      bn: 'দুঃখিত, আপনি যে ক্রিয়াটি সম্পাদন করার চেষ্টা করছেন তা কেবল প্রশাসকদের জন্য সীমাবদ্ধ। আপনি যদি বিশ্বাস করেন যে এই বৈশিষ্ট্যটির অ্যাক্সেস আপনার থাকা উচিত, অনুগ্রহ করে সহায়তার জন্য সিস্টেম অ্যাডমিনিস্ট্রেটরের সাথে যোগাযোগ করুন।',
      ru: 'Извините, действие, которое вы пытаетесь выполнить, доступно только администраторам. Если вы считаете, что должны иметь доступ к этой функции, обратитесь за помощью к системному администратору.',
      ja: '申し訳ありませんが、実行しようとしている操作は管理者のみが対象です。この機能へのアクセス権があるとお考えの場合は、システム管理者に連絡してください。',
      tr: 'Üzgünüz, gerçekleştirmeye çalıştığınız eylem yalnızca yöneticiler için kısıtlanmıştır. Bu özelliğe erişiminiz olması gerektiğini düşünüyorsanız, lütfen yardım için sistem yöneticisine başvurun.',
      ko: '죄송합니다. 수행하려는 작업은 관리자 전용입니다. 이 기능에 대한 액세스 권한이 있어야 한다고 생각되면 시스템 관리자에게 문의하십시오.',
      vi: 'Xin lỗi, hành động bạn đang cố gắng thực hiện chỉ dành cho quản trị viên. Nếu bạn tin rằng mình nên có quyền truy cập vào tính năng này, vui lòng liên hệ với quản trị viên hệ thống để được trợ giúp.',
      id: 'Maaf, tindakan yang Anda coba lakukan dibatasi hanya untuk administrator. Jika Anda yakin harus memiliki akses ke fitur ini, silakan hubungi administrator sistem untuk mendapatkan bantuan.',
      th: 'ขออภัย การดำเนินการที่คุณพยายามทำนั้นจำกัดเฉพาะผู้ดูแลระบบเท่านั้น หากคุณเชื่อว่าคุณควรสามารถเข้าถึงคุณลักษณะนี้ได้ โปรดติดต่อผู้ดูแลระบบเพื่อขอความช่วยเหลือ',
      ms: 'Maaf, tindakan yang anda cuba lakukan adalah terhad kepada pentadbir sahaja. Jika anda percaya anda patut mempunyai akses kepada ciri ini, sila hubungi pentadbir sistem untuk mendapatkan bantuan.',
      ar_eg:
        'عذرًا، الإجراء الذي تحاول تنفيذه مقصور على المسؤولين فقط. إذا كنت تعتقد أنه يجب أن يكون لديك حق الوصول إلى هذه الميزة، يرجى الاتصال بمسؤول النظام للحصول على المساعدة.',
      uk: 'Вибачте, дія, яку ви намагаєтесь виконати, доступна лише адміністраторам. Якщо ви вважаєте, що повинні мати доступ до цієї функції, зверніться за допомогою до системного адміністратора.',
    },
    archive_text: {
      en: 'Sorry, the action you’re trying to perform is restricted to administrators only. If you believe you should have access to this feature, please contact the system administrator for assistance.',
      es: 'Lo siento, la acción que está intentando realizar está restringida solo a los administradores. Si cree que debería tener acceso a esta función, comuníquese con el administrador del sistema para obtener ayuda.',
      fr: "Désolé, l'action que vous essayez d'effectuer est réservée aux administrateurs. Si vous pensez que vous devriez avoir accès à cette fonctionnalité, veuillez contacter l'administrateur du système pour obtenir de l'aide.",
      de: 'Entschuldigung, die Aktion, die Sie ausführen möchten, ist nur Administratoren vorbehalten. Wenn Sie der Meinung sind, dass Sie Zugriff auf diese Funktion haben sollten, wenden Sie sich bitte an den Systemadministrator, um Unterstützung zu erhalten.',
      pt: 'Desculpe, a ação que você está tentando realizar é restrita apenas aos administradores. Se você acredita que deve ter acesso a este recurso, entre em contato com o administrador do sistema para obter assistência.',
      pl: 'Przepraszamy, ale działanie, które próbujesz wykonać, jest zastrzeżone tylko dla administratorów. Jeśli uważasz, że powinieneś mieć dostęp do tej funkcji, skontaktuj się z administratorem systemu w celu uzyskania pomocy.',
      nl: 'Sorry, de actie die u probeert uit te voeren, is alleen voorbehouden aan beheerders. Als u denkt dat u toegang zou moeten hebben tot deze functie, neem dan contact op met de systeembeheerder voor hulp.',
      el: 'Συγγνώμη, η ενέργεια που προσπαθείτε να εκτελέσετε είναι περιορισμένη μόνο για τους διαχειριστές. Εάν πιστεύετε ότι θα έπρεπε να έχετε πρόσβαση σε αυτή τη δυνατότητα, επικοινωνήστε με τον διαχειριστή του συστήματος για βοήθεια.',
      cs: 'Omlouváme se, ale akce, kterou se pokoušíte provést, je omezena pouze na administrátory. Pokud si myslíte, že byste měli mít přístup k této funkci, obraťte se na správce systému.',
      sv: 'Tyvärr, åtgärden du försöker utföra är begränsad till endast administratörer. Om du tror att du borde ha tillgång till denna funktion, vänligen kontakta systemadministratören för hjälp.',
      hu: 'Sajnáljuk, az általad végrehajtani kívánt művelet csak rendszergazdák számára korlátozott. Ha úgy gondolod, hogy hozzá kellene férned ehhez a funkcióhoz, kérjük, fordulj a rendszergazdához segítségért.',
      da: 'Beklager, handlingen, du forsøger at udføre, er kun begrænset til administratorer. Hvis du mener, at du bør have adgang til denne funktion, bedes du kontakte systemadministratoren for assistance.',
      fi: 'Valitettavasti toiminto, jota yrität suorittaa, on rajoitettu vain ylläpitäjille. Jos uskot, että sinulla pitäisi olla pääsy tähän ominaisuuteen, ota yhteyttä järjestelmänvalvojaan saadaksesi apua.',
      sk: 'Ospravedlňujeme sa, ale akcia, ktorú sa pokúšate vykonať, je obmedzená iba na správcov. Ak si myslíte, že by ste mali mať prístup k tejto funkcii, kontaktujte správcu systému.',
      bg: 'Съжаляваме, действието, което се опитвате да извършите, е ограничено само за администратори. Ако смятате, че трябва да имате достъп до тази функция, моля, свържете се със системния администратор за помощ.',
      hr: 'Žao nam je, radnja koju pokušavate izvršiti ograničena je samo na administratore. Ako vjerujete da biste trebali imati pristup ovoj funkciji, obratite se administratoru sustava za pomoć.',
      lt: 'Atsiprašome, veiksmas, kurį bandote atlikti, yra skirtas tik administratoriams. Jei manote, kad turėtumėte turėti prieigą prie šios funkcijos, kreipkitės pagalbos į sistemos administratorių.',
      lv: 'Atvainojiet, darbība, kuru mēģināt veikt, ir ierobežota tikai administratoriem. Ja uzskatāt, ka jums vajadzētu būt pieejai šai funkcijai, lūdzu, sazinieties ar sistēmas administratoru, lai saņemtu palīdzību.',
      et: 'Vabandust, tegevus, mida proovite sooritada, on piiratud ainult administraatoritele. Kui usute, et peaksite sellele funktsioonile juurde pääsema, võtke abi saamiseks ühendust süsteemi administraatoriga.',
      sl: 'Opravičujemo se, dejanje, ki ga poskušate izvesti, je omejeno samo na skrbnike. Če menite, da bi morali imeti dostop do te funkcije, se obrnite na skrbnika sistema za pomoč.',
      ga: 'Tá brón orainn, tá an gníomh atá tú ag iarraidh a dhéanamh srianta do riarthóirí amháin. Má chreideann tú gur chóir go mbeadh rochtain agat ar an ngné seo, déan teagmháil leis an riarthóir córais le do thoil chun cúnamh a fháil.',
      mt: 'Jiddispjaċina, l-azzjoni li qed tipprova twettaq hija ristretta għal amministraturi biss. Jekk temmen li għandek ikollok aċċess għal din il-karatteristika, jekk jogħġbok ikkuntattja lill-amministratur tas-sistema għall-għajnuna.',
      cy: 'Mae’n ddrwg gennym, mae’r weithred rydych yn ceisio’i chyflawni wedi’i chyfyngu i weinyddwyr yn unig. Os credwch y dylech gael mynediad i’r nodwedd hon, cysylltwch â gweinyddwr y system am gymorth.',
      ro: 'Ne pare rău, acțiunea pe care încercați să o efectuați este restricționată doar pentru administratori. Dacă credeți că ar trebui să aveți acces la această funcție, vă rugăm să contactați administratorul de sistem pentru asistență.',
      it: "Spiacenti, l'azione che stai cercando di eseguire è riservata solo agli amministratori. Se ritieni di dover avere accesso a questa funzionalità, contatta l'amministratore di sistema per assistenza.",
      zh_cn: '对不起，您尝试执行的操作仅限于管理员。如果您认为您应该有权访问此功能，请联系系统管理员以获取帮助。',
      hi: 'माफ़ करें, जिस क्रिया को आप निष्पादित करने का प्रयास कर रहे हैं वह केवल प्रशासकों के लिए प्रतिबंधित है। यदि आपको लगता है कि आपको इस सुविधा का उपयोग करने की अनुमति होनी चाहिए, तो कृपया सहायता के लिए सिस्टम व्यवस्थापक से संपर्क करें।',
      ar: 'عذرًا، الإجراء الذي تحاول تنفيذه مقصور على المسؤولين فقط. إذا كنت تعتقد أنه يجب أن يكون لديك حق الوصول إلى هذه الميزة، يرجى الاتصال بمسؤول النظام للحصول على المساعدة.',
      bn: 'দুঃখিত, আপনি যে ক্রিয়াটি সম্পাদন করার চেষ্টা করছেন তা কেবল প্রশাসকদের জন্য সীমাবদ্ধ। আপনি যদি বিশ্বাস করেন যে এই বৈশিষ্ট্যটির অ্যাক্সেস আপনার থাকা উচিত, অনুগ্রহ করে সহায়তার জন্য সিস্টেম অ্যাডমিনিস্ট্রেটরের সাথে যোগাযোগ করুন।',
      ru: 'Извините, действие, которое вы пытаетесь выполнить, доступно только администраторам. Если вы считаете, что должны иметь доступ к этой функции, обратитесь за помощью к системному администратору.',
      ja: '申し訳ありませんが、実行しようとしている操作は管理者のみが対象です。この機能へのアクセス権があるとお考えの場合は、システム管理者に連絡してください。',
      tr: 'Üzgünüz, gerçekleştirmeye çalıştığınız eylem yalnızca yöneticiler için kısıtlanmıştır. Bu özelliğe erişiminiz olması gerektiğini düşünüyorsanız, lütfen yardım için sistem yöneticisine başvurun.',
      ko: '죄송합니다. 수행하려는 작업은 관리자 전용입니다. 이 기능에 대한 액세스 권한이 있어야 한다고 생각되면 시스템 관리자에게 문의하십시오.',
      vi: 'Xin lỗi, hành động bạn đang cố gắng thực hiện chỉ dành cho quản trị viên. Nếu bạn tin rằng mình nên có quyền truy cập vào tính năng này, vui lòng liên hệ với quản trị viên hệ thống để được trợ giúp.',
      id: 'Maaf, tindakan yang Anda coba lakukan dibatasi hanya untuk administrator. Jika Anda yakin harus memiliki akses ke fitur ini, silakan hubungi administrator sistem untuk mendapatkan bantuan.',
      th: 'ขออภัย การดำเนินการที่คุณพยายามทำนั้นจำกัดเฉพาะผู้ดูแลระบบเท่านั้น หากคุณเชื่อว่าคุณควรสามารถเข้าถึงคุณลักษณะนี้ได้ โปรดติดต่อผู้ดูแลระบบเพื่อขอความช่วยเหลือ',
      ms: 'Maaf, tindakan yang anda cuba lakukan adalah terhad kepada pentadbir sahaja. Jika anda percaya anda patut mempunyai akses kepada ciri ini, sila hubungi pentadbir sistem untuk mendapatkan bantuan.',
      ar_eg:
        'عذرًا، الإجراء الذي تحاول تنفيذه مقصور على المسؤولين فقط. إذا كنت تعتقد أنه يجب أن يكون لديك حق الوصول إلى هذه الميزة، يرجى الاتصال بمسؤول النظام للحصول على المساعدة.',
      uk: 'Вибачте, дія, яку ви намагаєтесь виконати, доступна лише адміністраторам. Якщо ви вважаєте, що повинні мати доступ до цієї функції, зверніться за допомогою до системного адміністратора.',
    },
  },
  no_data: {
    title: {
      en: 'No items has been added!',
      es: '¡No se han agregado artículos!',
      fr: "Aucun article n'a été ajouté !",
      de: 'Keine Artikel hinzugefügt!',
      pt: 'Nenhum item foi adicionado!',
      pl: 'Nie dodano żadnych przedmiotów!',
      nl: 'Geen items toegevoegd!',
      el: 'Δεν έχουν προστεθεί αντικείμενα!',
      cs: 'Nebyly přidány žádné položky!',
      sv: 'Inga artiklar har lagts till!',
      hu: 'Nem lett hozzáadva egyetlen elem sem!',
      da: 'Ingen varer er blevet tilføjet!',
      fi: 'Ei lisättyjä kohteita!',
      sk: 'Neboli pridané žiadne položky!',
      bg: 'Няма добавени артикули!',
      hr: 'Nije dodan nijedan predmet!',
      lt: 'Nepapildinta jokių daiktų!',
      lv: 'Nav pievienoti vienumi!',
      et: 'Ühtegi üksust pole lisatud!',
      sl: 'Ni dodanih elementov!',
      ga: 'Níor cuireadh aon mhír leis!',
      mt: 'L-ebda oġġetti ma ġew miżjuda!',
      cy: 'Ni ychwanegwyd unrhyw eitemau!',
      ro: 'Nu au fost adăugate articole!',
      it: 'Non sono stati aggiunti articoli!',
      zh_cn: '没有添加任何项目！',
      hi: 'कोई आइटम नहीं जोड़ा गया है!',
      ar: 'لم يتم إضافة أي عناصر!',
      bn: 'কোনও আইটেম যোগ করা হয়নি!',
      ru: 'Элементы не добавлены!',
      ja: 'アイテムが追加されていません！',
      tr: 'Hiçbir öğe eklenmedi!',
      ko: '추가된 항목이 없습니다!',
      vi: 'Không có mặt hàng nào được thêm!',
      id: 'Tidak ada barang yang ditambahkan!',
      th: 'ไม่มีรายการที่เพิ่ม!',
      ms: 'Tiada item ditambah!',
      ar_eg: 'لم تتم إضافة أي عناصر!',
      uk: 'Жодних предметів не додано!',
    },
    description: {
      en: 'Tap the <strong class="text-cool-gray-100 fw-500">‘Create New Item’</strong> button to add items to your library!',
      es: 'Toque el botón <strong class="text-cool-gray-100 fw-500">‘Crear Nuevo Artículo’</strong> para agregar artículos a su biblioteca!',
      fr: 'Appuyez sur le bouton <strong class="text-cool-gray-100 fw-500">‘Créer un Nouvel Article’</strong> pour ajouter des articles à votre bibliothèque!',
      de: 'Tippen Sie auf die Schaltfläche <strong class="text-cool-gray-100 fw-500">‘Neuen Artikel Erstellen’</strong>, um Artikel zu Ihrer Bibliothek hinzuzufügen!',
      pt: 'Toque no botão <strong class="text-cool-gray-100 fw-500">‘Criar Novo Item’</strong> para adicionar itens à sua biblioteca!',
      pl: 'Stuknij przycisk <strong class="text-cool-gray-100 fw-500">‘Utwórz Nowy Przedmiot’</strong>, aby dodać przedmioty do swojej biblioteki!',
      nl: 'Tik op de knop <strong class="text-cool-gray-100 fw-500">‘Nieuw Item Aanmaken’</strong> om items aan je bibliotheek toe te voegen!',
      el: 'Πατήστε το κουμπί <strong class="text-cool-gray-100 fw-500">‘Δημιουργία Νέου Στοιχείου’</strong> για να προσθέσετε αντικείμενα στη βιβλιοθήκη σας!',
      cs: 'Klepnutím na tlačítko <strong class="text-cool-gray-100 fw-500">‘Vytvořit Novou Položku’</strong> přidáte položky do své knihovny!',
      sv: 'Tryck på knappen <strong class="text-cool-gray-100 fw-500">‘Skapa Ny Artikel’</strong> för att lägga till artiklar i ditt bibliotek!',
      hu: 'Érintse meg az <strong class="text-cool-gray-100 fw-500">‘Új Elem Létrehozása’</strong> gombot, hogy hozzáadjon elemeket a könyvtárához!',
      da: 'Tryk på knappen <strong class="text-cool-gray-100 fw-500">‘Opret Ny Vare’</strong> for at tilføje varer til dit bibliotek!',
      fi: 'Napauta <strong class="text-cool-gray-100 fw-500">‘Luo Uusi Kohde’</strong> -painiketta lisätäksesi kohteita kirjastoon!',
      sk: 'Klepnite na tlačidlo <strong class="text-cool-gray-100 fw-500">‘Vytvoriť Novú Položku’</strong> a pridajte položky do svojej knižnice!',
      bg: 'Докоснете бутона <strong class="text-cool-gray-100 fw-500">‘Създаване на Нов Артикул’</strong>, за да добавите артикули към вашата библиотека!',
      hr: 'Dodirnite gumb <strong class="text-cool-gray-100 fw-500">‘Kreiraj Novu Stavku’</strong> za dodavanje predmeta u svoju knjižnicu!',
      lt: 'Bakstelėkite mygtuką <strong class="text-cool-gray-100 fw-500">‘Sukurti Naują Prekę’</strong>, kad pridėtumėte daiktų į savo biblioteką!',
      lv: 'Pieskarieties pogai <strong class="text-cool-gray-100 fw-500">‘Izveidot Jaunu Vienumu’</strong>, lai pievienotu vienumus savai bibliotēkai!',
      et: 'Puudutage nuppu <strong class="text-cool-gray-100 fw-500">‘Loo Uus Üksus’</strong>, et lisada üksusi oma teeki!',
      sl: 'Tapnite gumb <strong class="text-cool-gray-100 fw-500">‘Ustvari Novo Postavko’</strong>, da dodate elemente v svojo knjižnico!',
      ga: 'Beartaigh an cnaipe <strong class="text-cool-gray-100 fw-500">‘Cruthaigh Mír Nua’</strong> chun míreanna a chur le do leabharlann!',
      mt: 'Ikklikkja l-buttuna <strong class="text-cool-gray-100 fw-500">‘Oħloq Oġġett Ġdid’</strong> biex iżżid oġġetti mal-librerija tiegħek!',
      cy: 'Tapiwch y botwm <strong class="text-cool-gray-100 fw-500">‘Creu Eitem Newydd’</strong> i ychwanegu eitemau i’ch llyfrgell!',
      ro: 'Atingeți butonul <strong class="text-cool-gray-100 fw-500">‘Creează Articol Nou’</strong> pentru a adăuga articole în biblioteca dvs.!',
      it: 'Tocca il pulsante <strong class="text-cool-gray-100 fw-500">‘Crea Nuovo Articolo’</strong> per aggiungere articoli alla tua libreria!',
      zh_cn: '点击<strong class="text-cool-gray-100 fw-500">‘创建新项目’</strong>按钮，将项目添加到您的库中！',
      hi: '<strong class="text-cool-gray-100 fw-500">‘नया आइटम बनाएं’</strong> बटन को टैप करें और अपनी लाइब्रेरी में आइटम जोड़ें!',
      ar: 'انقر على زر <strong class="text-cool-gray-100 fw-500">‘إنشاء عنصر جديد’</strong> لإضافة عناصر إلى مكتبتك!',
      bn: '<strong class="text-cool-gray-100 fw-500">‘নতুন আইটেম তৈরি করুন’</strong> বোতামে আলতো চাপুন আপনার লাইব্রেরিতে আইটেম যোগ করতে!',
      ru: 'Нажмите кнопку <strong class="text-cool-gray-100 fw-500">‘Создать Новый Элемент’</strong>, чтобы добавить элементы в свою библиотеку!',
      ja: 'ライブラリにアイテムを追加するには、<strong class="text-cool-gray-100 fw-500">‘新しいアイテムを作成’</strong> ボタンをタップしてください！',
      tr: 'Kütüphanenize öğe eklemek için <strong class="text-cool-gray-100 fw-500">‘Yeni Öğe Oluştur’</strong> düğmesine dokunun!',
      ko: '항목을 라이브러리에 추가하려면 <strong class="text-cool-gray-100 fw-500">‘새 항목 만들기’</strong> 버튼을 누르세요!',
      vi: 'Nhấn vào nút <strong class="text-cool-gray-100 fw-500">‘Tạo Mặt Hàng Mới’</strong> để thêm mặt hàng vào thư viện của bạn!',
      id: 'Ketuk tombol <strong class="text-cool-gray-100 fw-500">‘Buat Barang Baru’</strong> untuk menambahkan barang ke perpustakaan Anda!',
      th: 'แตะปุ่ม <strong class="text-cool-gray-100 fw-500">‘สร้างรายการใหม่’</strong> เพื่อเพิ่มรายการในคลังของคุณ!',
      ms: 'Ketuk butang <strong class="text-cool-gray-100 fw-500">‘Buat Item Baru’</strong> untuk menambah item ke perpustakaan anda!',
      ar_eg:
        'انقر على زر <strong class="text-cool-gray-100 fw-500">‘إنشاء عنصر جديد’</strong> لإضافة عناصر إلى مكتبتك!',
      uk: 'Торкніться кнопки <strong class="text-cool-gray-100 fw-500">‘Створити Новий Елемент’</strong>, щоб додати елементи до своєї бібліотеки!',
    },
  },
  popup: {
    category_archive: {
      title: {
        en: 'Are you sure you want to archive this category?',
        es: '¿Estás seguro de que quieres archivar esta categoría?',
        fr: 'Êtes-vous sûr de vouloir archiver cette catégorie ?',
        de: 'Sind Sie sicher, dass Sie diese Kategorie archivieren möchten?',
        pt: 'Tem certeza de que deseja arquivar esta categoria?',
        pl: 'Czy na pewno chcesz zarchiwizować tę kategorię?',
        nl: 'Weet je zeker dat je deze categorie wilt archiveren?',
        el: 'Είστε βέβαιοι ότι θέλετε να αρχειοθετήσετε αυτή την κατηγορία;',
        cs: 'Opravdu chcete tuto kategorii archivovat?',
        sv: 'Är du säker på att du vill arkivera den här kategorin?',
        hu: 'Biztosan archiválni szeretné ezt a kategóriát?',
        da: 'Er du sikker på, at du vil arkivere denne kategori?',
        fi: 'Oletko varma, että haluat arkistoida tämän luokan?',
        sk: 'Ste si istí, že chcete túto kategóriu archivovať?',
        bg: 'Сигурни ли сте, че искате да архивирате тази категория?',
        hr: 'Jeste li sigurni da želite arhivirati ovu kategoriju?',
        lt: 'Ar tikrai norite archyvuoti šią kategoriją?',
        lv: 'Vai tiešām vēlaties arhivēt šo kategoriju?',
        et: 'Kas olete kindel, et soovite selle kategooria arhiveerida?',
        sl: 'Ali ste prepričani, da želite arhivirati to kategorijo?',
        ga: 'An bhfuil tú cinnte gur mhaith leat an chatagóir seo a chartlannú?',
        mt: 'Int żgur li trid tpoġġi din il-kategorija fl-arkivju?',
        cy: "Ydych chi'n siŵr eich bod chi eisiau archifo'r categori hwn?",
        ro: 'Sigur doriți să arhivați această categorie?',
        it: 'Sei sicuro di voler archiviare questa categoria?',
        zh_cn: '您确定要归档此类别吗？',
        hi: 'क्या आप वाकई इस श्रेणी को संग्रहित करना चाहते हैं?',
        ar: 'هل أنت متأكد من أنك تريد أرشفة هذه الفئة؟',
        bn: 'আপনি কি নিশ্চিত যে আপনি এই বিভাগটি সংরক্ষণ করতে চান?',
        ru: 'Вы уверены, что хотите архивировать эту категорию?',
        ja: 'このカテゴリをアーカイブしてもよろしいですか？',
        tr: 'Bu kategoriyi arşivlemek istediğinizden emin misiniz?',
        ko: '이 카테고리를 보관하시겠습니까?',
        vi: 'Bạn có chắc chắn muốn lưu trữ danh mục này không?',
        id: 'Apakah Anda yakin ingin mengarsipkan kategori ini?',
        th: 'คุณแน่ใจหรือว่าต้องการจัดเก็บหมวดหมู่นี้?',
        ms: 'Adakah anda pasti mahu mengarkibkan kategori ini?',
        ar_eg: 'هل أنت متأكد أنك تريد أرشفة هذه الفئة؟',
        uk: 'Ви впевнені, що хочете архівувати цю категорію?',
      },
      description: {
        en: "Archiving will remove the “category” from your active “inventory list” but don't worry, you can always restore it later from <strong>Settings > Archive</strong>",
        es: 'Archivar eliminará la “categoría” de su “lista de inventario” activa, pero no se preocupe, siempre puede restaurarla más tarde desde <strong>Configuración > Archivo</strong>',
        fr: "L'archivage supprimera la « catégorie » de votre « liste d'inventaire » active, mais ne vous inquiétez pas, vous pouvez toujours la restaurer plus tard depuis <strong>Paramètres > Archive</strong>",
        de: 'Das Archivieren entfernt die „Kategorie“ aus Ihrer aktiven „Inventarliste“, aber keine Sorge, Sie können sie später jederzeit über <strong>Einstellungen > Archiv</strong> wiederherstellen',
        pt: 'Arquivar removerá a “categoria” da sua “lista de inventário” ativa, mas não se preocupe, você sempre pode restaurá-la mais tarde em <strong>Configurações > Arquivo</strong>',
        pl: 'Archiwizacja usunie „kategorię” z twojej aktywnej „listy inwentarza”, ale nie martw się, zawsze możesz ją przywrócić później z <strong>Ustawienia > Archiwum</strong>',
        nl: 'Archiveren verwijdert de “categorie” uit je actieve “inventarislijst”, maar maak je geen zorgen, je kunt deze later altijd herstellen via <strong>Instellingen > Archief</strong>',
        el: 'Η αρχειοθέτηση θα αφαιρέσει την «κατηγορία» από τη «λίστα απογραφής» σας, αλλά μην ανησυχείτε, μπορείτε πάντα να την επαναφέρετε αργότερα από τις <strong>Ρυθμίσεις > Αρχείο</strong>',
        cs: 'Archivace odstraní „kategorii“ z vašeho aktivního „seznamu inventáře“, ale nebojte se, můžete ji kdykoli později obnovit z <strong>Nastavení > Archiv</strong>',
        sv: 'Arkivering tar bort ”kategorin” från din aktiva ”inventarielista”, men oroa dig inte, du kan alltid återställa den senare från <strong>Inställningar > Arkiv</strong>',
        hu: 'Az archiválás eltávolítja a „kategóriát” az aktív „leltárlistából”, de ne aggódjon, később bármikor visszaállíthatja a <strong>Beállítások > Archívum</strong> menüpontból',
        da: 'Arkivering vil fjerne “kategorien” fra din aktive “lagerliste”, men bare rolig, du kan altid gendanne den senere fra <strong>Indstillinger > Arkiv</strong>',
        fi: 'Arkistointi poistaa ”luokan” aktiivisesta ”varastoluettelostasi”, mutta älä huoli, voit aina palauttaa sen myöhemmin kohdasta <strong>Asetukset > Arkisto</strong>',
        sk: 'Archivácia odstráni „kategóriu“ z vášho aktívneho „zoznamu inventára“, ale nebojte sa, môžete ju kedykoľvek neskôr obnoviť v časti <strong>Nastavenia > Archív</strong>',
        bg: 'Архивирането ще премахне „категорията“ от вашия активен „инвентарен списък“, но не се притеснявайте, винаги можете да я възстановите по-късно от <strong>Настройки > Архив</strong>',
        hr: 'Arhiviranje će ukloniti „kategoriju“ s vašeg aktivnog „popisa inventara“, ali ne brinite, uvijek je možete kasnije vratiti iz <strong>Postavke > Arhiva</strong>',
        lt: 'Archyvuojant bus pašalinta „kategorija“ iš jūsų aktyvaus „inventoriaus sąrašo“, tačiau nesijaudinkite, visada galite ją vėliau atkurti iš <strong>Nustatymai > Archyvas</strong>',
        lv: 'Arhivējot „kategorija“ tiks noņemta no jūsu aktīvā „inventāra saraksta“, bet neuztraucieties, jūs vienmēr varat to vēlāk atjaunot no <strong>Iestatījumi > Arhīvs</strong>',
        et: 'Arhiveerimine eemaldab „kategooria” teie aktiivsest „inventeerimisloendist”, kuid ärge muretsege, saate selle alati hiljem taastada jaotises <strong>Seaded > Arhiiv</strong>',
        sl: 'Arhiviranje bo odstranilo »kategorijo« z vašega aktivnega »seznama inventarja«, vendar ne skrbite, vedno jo lahko pozneje obnovite iz <strong>Nastavitve > Arhiv</strong>',
        ga: 'Bainfidh cartlannú an “chatagóir” as do “liosta fardail” gníomhach ach ná bí buartha, is féidir leat é a chur ar ais níos déanaí ó <strong>Socruithe > Cartlann</strong>',
        mt: "L-arkivjar se jneħħi l-“kategorija” mil-“lista tal-inventarju” attiva tiegħek, imma tinkwetax, tista' dejjem tirkuprah aktar tard minn <strong>Settings > Archive</strong>",
        cy: "Bydd archifo yn tynnu'r “categori” o'ch “rhestr rhestr eiddo” weithredol ond peidiwch â phoeni, gallwch chi bob amser ei adfer yn nes ymlaen o <strong>Gosodiadau > Archif</strong>",
        ro: 'Arhivarea va elimina „categoria” din „lista de inventar” activă, dar nu vă faceți griji, o puteți restaura oricând mai târziu din <strong>Setări > Arhivă</strong>',
        it: "L'archiviazione rimuoverà la “categoria” dal tuo “elenco inventario” attivo, ma non preoccuparti, puoi sempre ripristinarla in seguito da <strong>Impostazioni > Archivio</strong>",
        zh_cn: '归档将从您的“库存列表”中删除“类别”，但别担心，您可以随时从<strong>设置 > 归档</strong>中恢复它',
        hi: 'संग्रहण से आपकी सक्रिय “सूची सूची” से “श्रेणी” हटा दी जाएगी, लेकिन चिंता न करें, आप इसे बाद में <strong>सेटिंग्स > संग्रह</strong> से पुनः प्राप्त कर सकते हैं',
        ar: 'ستؤدي الأرشفة إلى إزالة "الفئة" من "قائمة الجرد" النشطة لديك ولكن لا تقلق، يمكنك دائمًا استعادتها لاحقًا من <strong>الإعدادات > الأرشيف</strong>',
        bn: 'আর্কাইভিং আপনার সক্রিয় "তালিকা তালিকা" থেকে "বিভাগ" সরিয়ে দেবে তবে চিন্তা করবেন না, আপনি সর্বদা <strong>সেটিংস > আর্কাইভ</strong> থেকে এটি পরে পুনরুদ্ধার করতে পারবেন',
        ru: 'Архивирование удалит «категорию» из вашего активного «списка инвентаря», но не волнуйтесь, вы всегда можете восстановить её позже из <strong>Настройки > Архив</strong>',
        ja: 'アーカイブすると、アクティブな「在庫リスト」から「カテゴリ」が削除されますが、心配しないでください。「設定 > アーカイブ」からいつでも復元できます',
        tr: 'Arşivleme, “kategoriyi” etkin “envanter listenizden” kaldıracaktır, ancak endişelenmeyin, daha sonra <strong>Ayarlar > Arşiv</strong> bölümünden her zaman geri yükleyebilirsiniz',
        ko: '아카이브하면 활성 “재고 목록”에서 “카테고리”가 제거되지만 걱정하지 마십시오. 나중에 <strong>설정 > 아카이브</strong>에서 언제든지 복원할 수 있습니다',
        vi: 'Lưu trữ sẽ xóa “danh mục” khỏi “danh sách kiểm kê” đang hoạt động của bạn nhưng đừng lo lắng, bạn luôn có thể khôi phục lại mục đó sau từ <strong>Cài đặt > Lưu trữ</strong>',
        id: 'Mengarsipkan akan menghapus “kategori” dari “daftar inventaris” aktif Anda tetapi jangan khawatir, Anda selalu dapat memulihkannya nanti dari <strong>Pengaturan > Arsip</strong>',
        th: 'การจัดเก็บจะลบ “หมวดหมู่” ออกจาก “รายการสินค้าคงคลัง” ที่ใช้งานอยู่ของคุณ แต่ไม่ต้องกังวล คุณสามารถกู้คืนได้ในภายหลังจาก <strong>การตั้งค่า > เอกสารเก่า</strong>',
        ms: 'Pengarkiban akan mengalih keluar “kategori” daripada “senarai inventori” aktif anda tetapi jangan risau, anda sentiasa boleh memulihkannya kemudian daripada <strong>Tetapan > Arkib</strong>',
        ar_eg:
          'ستؤدي أرشفة هذا العنصر إلى إزالته من "قائمة الجرد" النشطة الخاصة بك، ولكن لا تقلق، يمكنك دائمًا استعادته لاحقًا من <strong>الإعدادات > الأرشيف</strong>',
        uk: 'Архівування видалить «категорію» із вашого активного «списку інвентаризації», але не хвилюйтеся, ви завжди можете відновити її пізніше з <strong>Налаштування > Архів</strong>',
      },
    },
    item_archive: {
      title: {
        en: 'Are you sure you want to archive this item?',
        es: '¿Estás seguro de que quieres archivar este elemento?',
        fr: 'Êtes-vous sûr de vouloir archiver cet élément ?',
        de: 'Sind Sie sicher, dass Sie diesen Artikel archivieren möchten?',
        pt: 'Tem certeza de que deseja arquivar este item?',
        pl: 'Czy na pewno chcesz zarchiwizować ten element?',
        nl: 'Weet je zeker dat je dit item wilt archiveren?',
        el: 'Είστε βέβαιοι ότι θέλετε να αρχειοθετήσετε αυτό το στοιχείο;',
        cs: 'Opravdu chcete tuto položku archivovat?',
        sv: 'Är du säker på att du vill arkivera detta objekt?',
        hu: 'Biztosan archiválni szeretné ezt az elemet?',
        da: 'Er du sikker på, at du vil arkivere dette element?',
        fi: 'Oletko varma, että haluat arkistoida tämän kohteen?',
        sk: 'Ste si istí, že chcete túto položku archivovať?',
        bg: 'Сигурни ли сте, че искате да архивирате този елемент?',
        hr: 'Jeste li sigurni da želite arhivirati ovu stavku?',
        lt: 'Ar tikrai norite archyvuoti šį elementą?',
        lv: 'Vai tiešām vēlaties arhivēt šo vienumu?',
        et: 'Kas olete kindel, et soovite selle üksuse arhiveerida?',
        sl: 'Ali ste prepričani, da želite arhivirati to postavko?',
        ga: 'An bhfuil tú cinnte gur mhaith leat an mhír seo a chartlannú?',
        mt: 'Int żgur li trid tpoġġi dan l-oġġett fl-arkivju?',
        cy: "Ydych chi'n siŵr eich bod chi eisiau archifo'r eitem hon?",
        ro: 'Sigur doriți să arhivați acest element?',
        it: 'Sei sicuro di voler archiviare questo elemento?',
        zh_cn: '您确定要归档此项目吗？',
        hi: 'क्या आप वाकई इस वस्तु को संग्रहित करना चाहते हैं?',
        ar: 'هل أنت متأكد من أنك تريد أرشفة هذا العنصر؟',
        bn: 'আপনি কি নিশ্চিত যে আপনি এই আইটেমটি সংরক্ষণ করতে চান?',
        ru: 'Вы уверены, что хотите архивировать этот элемент?',
        ja: 'このアイテムをアーカイブしてもよろしいですか？',
        tr: 'Bu öğeyi arşivlemek istediğinizden emin misiniz?',
        ko: '이 항목을 보관하시겠습니까?',
        vi: 'Bạn có chắc chắn muốn lưu trữ mục này không?',
        id: 'Apakah Anda yakin ingin mengarsipkan item ini?',
        th: 'คุณแน่ใจหรือว่าต้องการจัดเก็บรายการนี้?',
        ms: 'Adakah anda pasti mahu mengarkibkan item ini?',
        ar_eg: 'هل أنت متأكد أنك تريد أرشفة هذا العنصر؟',
        uk: 'Ви впевнені, що хочете архівувати цей елемент?',
      },
      title_plural: {
        en: 'Are you sure you want to archive these items?',
        es: '¿Estás seguro de que quieres archivar estos elementos?',
        fr: 'Êtes-vous sûr de vouloir archiver ces éléments ?',
        de: 'Sind Sie sicher, dass Sie diese Elemente archivieren möchten?',
        pt: 'Tem certeza de que deseja arquivar esses itens?',
        pl: 'Czy na pewno chcesz zarchiwizować te elementy?',
        nl: 'Weet u zeker dat u deze items wilt archiveren?',
        el: 'Είστε βέβαιοι ότι θέλετε να αρχειοθετήσετε αυτά τα στοιχεία;',
        cs: 'Jste si jisti, že chcete archivovat tyto položky?',
        sv: 'Är du säker på att du vill arkivera dessa objekt?',
        hu: 'Biztos, hogy archiválni szeretné ezeket az elemeket?',
        da: 'Er du sikker på, at du vil arkivere disse elementer?',
        fi: 'Oletko varma, että haluat arkistoida nämä kohteet?',
        sk: 'Ste si istí, že chcete archivovať tieto položky?',
        bg: 'Сигурни ли сте, че искате да архивирате тези елементи?',
        hr: 'Jeste li sigurni da želite arhivirati ove stavke?',
        lt: 'Ar tikrai norite archyvuoti šiuos elementus?',
        lv: 'Vai tiešām vēlaties arhivēt šos vienumus?',
        et: 'Kas olete kindel, et soovite need üksused arhiveerida?',
        sl: 'Ste prepričani, da želite arhivirati te elemente?',
        ga: 'An bhfuil tú cinnte gur mian leat na míreanna seo a chartlannú?',
        mt: 'Int żgur li trid tgħaddi dawn l-oġġetti għall-arkivju?',
        cy: 'Ydych chi’n siŵr eich bod am archifo’r eitemau hyn?',
        ro: 'Sigur doriți să arhivați aceste elemente?',
        it: 'Sei sicuro di voler archiviare questi elementi?',
        zh_cn: '您确定要存档这些项目吗？',
        hi: 'क्या आप वाकई इन वस्तुओं को संग्रहित करना चाहते हैं?',
        ar: 'هل أنت متأكد أنك تريد أرشفة هذه العناصر؟',
        bn: 'আপনি কি নিশ্চিত যে আপনি এই আইটেমগুলি আর্কাইভ করতে চান?',
        ru: 'Вы уверены, что хотите архивировать эти элементы?',
        ja: 'これらの項目をアーカイブしてもよろしいですか？',
        tr: 'Bu öğeleri arşivlemek istediğinizden emin misiniz?',
        ko: '이 항목들을 아카이브하시겠습니까?',
        vi: 'Bạn có chắc chắn muốn lưu trữ các mục này không?',
        id: 'Apakah Anda yakin ingin mengarsipkan item ini?',
        th: 'คุณแน่ใจหรือว่าต้องการเก็บรายการเหล่านี้ไว้ในคลัง?',
        ms: 'Adakah anda pasti mahu arkibkan item ini?',
        ar_eg: 'هل أنت متأكد أنك تريد أرشفة هذه العناصر؟',
        uk: 'Ви впевнені, що хочете архівувати ці елементи?',
      },
      description: {
        en: "Archiving will remove the “item” from your active “inventory list” but don't worry, you can always restore it later from <strong>Settings > Archive</strong>",
        es: 'Archivar eliminará el “elemento” de su “lista de inventario” activa, pero no se preocupe, siempre puede restaurarlo más tarde desde <strong>Configuración > Archivo</strong>',
        fr: "L'archivage supprimera l'“élément” de votre “liste d'inventaire” active, mais ne vous inquiétez pas, vous pouvez toujours le restaurer plus tard depuis <strong>Paramètres > Archive</strong>",
        de: 'Das Archivieren entfernt den „Artikel“ aus Ihrer aktiven „Inventarliste“, aber keine Sorge, Sie können ihn später jederzeit über <strong>Einstellungen > Archiv</strong> wiederherstellen',
        pt: 'Arquivar removerá o “item” da sua “lista de inventário” ativa, mas não se preocupe, você sempre pode restaurá-lo mais tarde em <strong>Configurações > Arquivo</strong>',
        pl: 'Archiwizacja usunie „element” z twojej aktywnej „listy inwentarza”, ale nie martw się, zawsze możesz go przywrócić później z <strong>Ustawienia > Archiwum</strong>',
        nl: 'Archiveren verwijdert het “item” uit je actieve “inventarislijst”, maar maak je geen zorgen, je kunt het later altijd herstellen via <strong>Instellingen > Archief</strong>',
        el: 'Η αρχειοθέτηση θα αφαιρέσει το «στοιχείο» από τη «λίστα απογραφής» σας, αλλά μην ανησυχείτε, μπορείτε πάντα να το επαναφέρετε αργότερα από τις <strong>Ρυθμίσεις > Αρχείο</strong>',
        cs: 'Archivace odstraní „položku“ z vašeho aktivního „seznamu inventáře“, ale nebojte se, můžete ji kdykoli později obnovit z <strong>Nastavení > Archiv</strong>',
        sv: 'Arkivering tar bort ”objektet” från din aktiva ”inventarielista”, men oroa dig inte, du kan alltid återställa det senare från <strong>Inställningar > Arkiv</strong>',
        hu: 'Az archiválás eltávolítja az „elemet” az aktív „leltárlistából”, de ne aggódjon, később bármikor visszaállíthatja a <strong>Beállítások > Archívum</strong> menüpontból',
        da: 'Arkivering vil fjerne “elementet” fra din aktive “lagerliste”, men bare rolig, du kan altid gendanne det senere fra <strong>Indstillinger > Arkiv</strong>',
        fi: 'Arkistointi poistaa ”kohteen” aktiivisesta ”varastoluettelostasi”, mutta älä huoli, voit aina palauttaa sen myöhemmin kohdasta <strong>Asetukset > Arkisto</strong>',
        sk: 'Archivácia odstráni „položku“ z vášho aktívneho „zoznamu inventára“, ale nebojte sa, môžete ju kedykoľvek neskôr obnoviť v časti <strong>Nastavenia > Archív</strong>',
        bg: 'Архивирането ще премахне „елемента“ от вашия активен „инвентарен списък“, но не се притеснявайте, винаги можете да го възстановите по-късно от <strong>Настройки > Архив</strong>',
        hr: 'Arhiviranje će ukloniti „stavku“ s vašeg aktivnog „popisa inventara“, ali ne brinite, uvijek je možete kasnije vratiti iz <strong>Postavke > Arhiva</strong>',
        lt: 'Archyvuojant bus pašalintas „elementas“ iš jūsų aktyvaus „inventoriaus sąrašo“, tačiau nesijaudinkite, visada galite jį vėliau atkurti iš <strong>Nustatymai > Archyvas</strong>',
        lv: 'Arhivējot „vienums“ tiks noņemts no jūsu aktīvā „inventāra saraksta“, bet neuztraucieties, jūs vienmēr varat to vēlāk atjaunot no <strong>Iestatījumi > Arhīvs</strong>',
        et: 'Arhiveerimine eemaldab „üksuse” teie aktiivsest „inventeerimisloendist”, kuid ärge muretsege, saate selle alati hiljem taastada jaotises <strong>Seaded > Arhiiv</strong>',
        sl: 'Arhiviranje bo odstranilo »postavko« z vašega aktivnega »seznama inventarja«, vendar ne skrbite, vedno jo lahko pozneje obnovite iz <strong>Nastavitve > Arhiv</strong>',
        ga: 'Bainfidh cartlannú an “mír” as do “liosta fardail” gníomhach ach ná bí buartha, is féidir leat é a chur ar ais níos déanaí ó <strong>Socruithe > Cartlann</strong>',
        mt: "L-arkivjar se jneħħi l-“oġġett” mil-“lista tal-inventarju” attiva tiegħek, imma tinkwetax, tista' dejjem tirkuprah aktar tard minn <strong>Settings > Archive</strong>",
        cy: "Bydd archifo yn tynnu'r “eitem” o'ch “rhestr rhestr eiddo” weithredol ond peidiwch â phoeni, gallwch chi bob amser ei adfer yn nes ymlaen o <strong>Gosodiadau > Archif</strong>",
        ro: 'Arhivarea va elimina „elementul” din „lista de inventar” activă, dar nu vă faceți griji, îl puteți restaura oricând mai târziu din <strong>Setări > Arhivă</strong>',
        it: "L'archiviazione rimuoverà l'“elemento” dal tuo “elenco inventario” attivo, ma non preoccuparti, puoi sempre ripristinarlo in seguito da <strong>Impostazioni > Archivio</strong>",
        zh_cn: '归档将从您的“库存列表”中删除“项目”，但别担心，您可以随时从<strong>设置 > 归档</strong>中恢复它',
        hi: 'संग्रहण से आपकी सक्रिय “सूची सूची” से “वस्तु” हटा दी जाएगी, लेकिन चिंता न करें, आप इसे बाद में <strong>सेटिंग्स > संग्रह</strong> से पुनः प्राप्त कर सकते हैं',
        ar: 'ستؤدي الأرشفة إلى إزالة "العنصر" من "قائمة الجرد" النشطة لديك ولكن لا تقلق، يمكنك دائمًا استعادته لاحقًا من <strong>الإعدادات > الأرشيف</strong>',
        bn: 'আর্কাইভিং আপনার সক্রিয় "তালিকা তালিকা" থেকে "আইটেম" সরিয়ে দেবে তবে চিন্তা করবেন না, আপনি সর্বদা <strong>সেটিংস > আর্কাইভ</strong> থেকে এটি পরে পুনরুদ্ধার করতে পারবেন',
        ru: 'Архивирование удалит «элемент» из вашего активного «списка инвентаря», но не волнуйтесь, вы всегда можете восстановить его позже из <strong>Настройки > Архив</strong>',
        ja: 'アーカイブすると、アクティブな「在庫リスト」から「アイテム」が削除されますが、心配しないでください。「設定 > アーカイブ」からいつでも復元できます',
        tr: 'Arşivleme, “öğe”yi etkin “envanter listenizden” kaldıracaktır, ancak endişelenmeyin, daha sonra <strong>Ayarlar > Arşiv</strong> bölümünden her zaman geri yükleyebilirsiniz',
        ko: '아카이브하면 활성 “재고 목록”에서 “항목”이 제거되지만 걱정하지 마십시오. 나중에 <strong>설정 > 아카이브</strong>에서 언제든지 복원할 수 있습니다',
        vi: 'Lưu trữ sẽ xóa “mục” khỏi “danh sách kiểm kê” đang hoạt động của bạn nhưng đừng lo lắng, bạn luôn có thể khôi phục lại mục đó sau từ <strong>Cài đặt > Lưu trữ</strong>',
        id: 'Mengarsipkan akan menghapus “item” dari “daftar inventaris” aktif Anda tetapi jangan khawatir, Anda selalu dapat memulihkannya nanti dari <strong>Pengaturan > Arsip</strong>',
        th: 'การจัดเก็บจะลบ “รายการ” ออกจาก “รายการสินค้าคงคลัง” ที่ใช้งานอยู่ของคุณ แต่ไม่ต้องกังวล คุณสามารถกู้คืนได้ในภายหลังจาก <strong>การตั้งค่า > เอกสารเก่า</strong>',
        ms: 'Pengarkiban akan mengalih keluar “item” daripada “senarai inventori” aktif anda tetapi jangan risau, anda sentiasa boleh memulihkannya kemudian daripada <strong>Tetapan > Arkib</strong>',
        ar_eg:
          'ستؤدي أرشفة هذا العنصر إلى إزالته من "قائمة الجرد" النشطة الخاصة بك، ولكن لا تقلق، يمكنك دائمًا استعادته لاحقًا من <strong>الإعدادات > الأرشيف</strong>',
        uk: 'Архівування видалить «елемент» із вашого активного «списку інвентаризації», але не хвилюйтеся, ви завжди можете відновити його пізніше з <strong>Налаштування > Архів</strong>',
      },
    },
  },
  modifiers: {
    add_ones: {
      en: 'Add-Ons',
      es: 'Complementos',
      fr: 'Suppléments',
      de: 'Zusätze',
      pt: 'Complementos',
      pl: 'Dodatki',
      nl: 'Toevoegingen',
      el: 'Πρόσθετα',
      cs: 'Doplňky',
      sv: 'Tillägg',
      hu: 'Kiegészítők',
      da: 'Tilføjelser',
      fi: 'Lisäosat',
      sk: 'Doplnky',
      bg: 'Добавки',
      hr: 'Dodaci',
      lt: 'Papildymai',
      lv: 'Papildinājumi',
      et: 'Lisandused',
      sl: 'Dodatki',
      ga: 'Breiseáin',
      mt: 'Add-Ons',
      cy: 'Ychwanegiadau',
      ro: 'Adăugiri',
      it: 'Componenti aggiuntivi',
      zh_cn: '附加组件',
      hi: 'एड-ऑन',
      ar: 'الإضافات',
      bn: 'অ্যাড-অন',
      ru: 'Дополнения',
      ja: '追加機能',
      tr: 'Eklentiler',
      ko: '추가 기능',
      vi: 'Tiện Ích Bổ Sung',
      id: 'Tambahan',
      th: 'ส่วนเสริม',
      ms: 'Tambah',
      ar_eg: 'الإضافات',
      uk: 'Доповнення',
    },
    connected_modifier_group: {
      en: 'Connected Modifier Group',
      es: 'Grupo de Modificadores Conectados',
      fr: 'Groupe de Modificateurs Connectés',
      de: 'Verbundene Modifikatorengruppe',
      pt: 'Grupo de Modificadores Conectados',
      pl: 'Połączona Grupa Modyfikatorów',
      nl: 'Verbonden Modificatorgroep',
      el: 'Συνδεδεμένη Ομάδα Τροποποιητών',
      cs: 'Připojená Skupina Modifikátorů',
      sv: 'Ansluten Modifierargrupp',
      hu: 'Csatlakoztatott Módosítócsoport',
      da: 'Forbundet Modifieringsgruppe',
      fi: 'Yhdistetty Modifikaattoriryhmä',
      sk: 'Pripojená Skupina Modifikátorov',
      bg: 'Свързана Група Модификатори',
      hr: 'Povezana Grupa Modifikatora',
      lt: 'Susietų Modifikatorių Grupė',
      lv: 'Saistīto Modifikatoru Grupa',
      et: 'Ühendatud Modifikaatorite Grupp',
      sl: 'Povezana Skupina Modifikatorjev',
      ga: 'Grúpa Modhnóra Ceangailte',
      mt: "Grupp ta' Modifikaturi Konnessi",
      cy: 'Grŵp Addasydd Cysylltiedig',
      ro: 'Grup de Modificatori Conectați',
      it: 'Gruppo di Modificatori Connessi',
      zh_cn: '连接的修饰符组',
      hi: 'कनेक्टेड संशोधक समूह',
      ar: 'مجموعة المُعدِّل المتصل',
      bn: 'সংযুক্ত মডিফায়ার গ্রুপ',
      ru: 'Подключенная группа модификаторов',
      ja: '接続された修飾子グループ',
      tr: 'Bağlı Değiştirici Grubu',
      ko: '연결된 수정자 그룹',
      vi: 'Nhóm Bộ Điều Chỉnh Được Kết Nối',
      id: 'Grup Modifikator Terhubung',
      th: 'กลุ่มตัวปรับแต่งที่เชื่อมต่อ',
      ms: 'Kumpulan Pengubah Bersambung',
      ar_eg: 'مجموعة المعدل المتصل',
      uk: 'Підключена група модифікаторів',
    },
    available_for_online_orders: {
      en: 'Available for Online Orders',
      es: 'Disponible para pedidos en línea',
      fr: 'Disponible pour les commandes en ligne',
      de: 'Verfügbar für Online-Bestellungen',
      pt: 'Disponível para pedidos online',
      pl: 'Dostępne dla zamówień online',
      nl: 'Beschikbaar voor online bestellingen',
      el: 'Διαθέσιμο για διαδικτυακές παραγγελίες',
      cs: 'Dostupné pro online objednávky',
      sv: 'Tillgänglig för onlinebeställningar',
      hu: 'Elérhető online rendeléshez',
      da: 'Tilgængelig for online bestillinger',
      fi: 'Saatavilla verkkotilauksille',
      sk: 'Dostupné pre online objednávky',
      bg: 'Наличен за онлайн поръчки',
      hr: 'Dostupno za online narudžbe',
      lt: 'Prieinama internetiniams užsakymams',
      lv: 'Pieejams tiešsaistes pasūtījumiem',
      et: 'Saadaval veebitellimusteks',
      sl: 'Na voljo za spletna naročila',
      ga: 'Ar fáil le haghaidh Orduithe Ar Líne',
      mt: 'Disponibbli għall-Ordni Onlajn',
      cy: 'Ar gael ar gyfer Archebion Ar-lein',
      ro: 'Disponibil pentru comenzi online',
      it: 'Disponibile per ordini online',
      zh_cn: '可用于在线订购',
      hi: 'ऑनलाइन ऑर्डर के लिए उपलब्ध',
      ar: 'متاح للطلبات عبر الإنترنت',
      bn: 'অনলাইন অর্ডারের জন্য উপলব্ধ',
      ru: 'Доступно для онлайн-заказов',
      ja: 'オンライン注文に利用可能',
      tr: 'Çevrimiçi Siparişler için Mevcut',
      ko: '온라인 주문 가능',
      vi: 'Có sẵn cho đơn đặt hàng trực tuyến',
      id: 'Tersedia untuk Pesanan Online',
      th: 'พร้อมสำหรับการสั่งซื้อออนไลน์',
      ms: 'Tersedia untuk Pesanan Dalam Talian',
      ar_eg: 'متاح للطلبات عبر الإنترنت',
      uk: 'Доступно для онлайн-замовлень',
    },
  },
  pos: {
    title: {
      en: 'POS Behaviour',
      es: 'Comportamiento del POS',
      fr: 'Comportement du POS',
      de: 'POS-Verhalten',
      pt: 'Comportamento do POS',
      pl: 'Zachowanie POS',
      nl: 'POS Gedrag',
      el: 'Συμπεριφορά POS',
      cs: 'Chování POS',
      sv: 'POS Beteende',
      hu: 'POS Viselkedés',
      da: 'POS Adfærd',
      fi: 'POS Käyttäytyminen',
      sk: 'Správanie POS',
      bg: 'Поведение на POS',
      hr: 'POS Ponašanje',
      lt: 'POS Elgesys',
      lv: 'POS Uzvedība',
      et: 'POS Käitumine',
      sl: 'Obnašanje POS',
      ga: 'Iompar POS',
      mt: 'Imġiba POS',
      cy: 'Ymddygiad POS',
      ro: 'Comportamentul POS',
      it: 'Comportamento del POS',
      zh_cn: 'POS行为',
      hi: 'POS व्यवहार',
      ar: 'سلوك POS',
      bn: 'POS আচরণ',
      ru: 'Поведение POS',
      ja: 'POSの動作',
      tr: 'POS Davranışı',
      ko: 'POS 동작',
      vi: 'Hành Vi POS',
      id: 'Perilaku POS',
      th: 'พฤติกรรม POS',
      ms: 'Tingkah Laku POS',
      ar_eg: 'سلوك POS',
      uk: 'Поведение POS',
    },
    max_order_qty: {
      en: 'Maximum Order QTY',
      es: 'Cantidad Máxima de Pedido',
      fr: 'Quantité de Commande Maximale',
      de: 'Maximale Bestellmenge',
      pt: 'Quantidade Máxima de Pedido',
      pl: 'Maksymalna Ilość Zamówienia',
      nl: 'Maximale Bestelhoeveelheid',
      el: 'Μέγιστη Ποσότητα Παραγγελίας',
      cs: 'Maximální Množství Objednávky',
      sv: 'Maximal Orderkvantitet',
      hu: 'Maximális Rendelési Mennyiség',
      da: 'Maksimal Ordremængde',
      fi: 'Suurin Tilausmäärä',
      sk: 'Maximálne Množstvo Objednávky',
      bg: 'Максимално Количество на Поръчката',
      hr: 'Maksimalna Količina Narudžbe',
      lt: 'Didžiausias Užsakymo Kiekis',
      lv: 'Maksimālais Pasūtījuma Daudzums',
      et: 'Maksimaalne Tellimuse Kogus',
      sl: 'Največja Količina Naročila',
      ga: 'Cainníocht Ordaithe Uasta',
      mt: 'Kwantità Massima tal-Ordni',
      cy: 'Maint Gorchymyn Uchafswm',
      ro: 'Cantitatea Maximă de Comandă',
      it: "Quantità Massima d'Ordine",
      zh_cn: '最大订单数量',
      hi: 'अधिकतम ऑर्डर मात्रा',
      ar: 'الحد الأقصى للكمية المطلوبة',
      bn: 'সর্বাধিক অর্ডার পরিমাণ',
      ru: 'Максимальное количество заказа',
      ja: '最大注文数量',
      tr: 'Maksimum Sipariş Miktarı',
      ko: '최대 주문 수량',
      vi: 'Số Lượng Đặt Hàng Tối Đa',
      id: 'Kuantitas Pesanan Maksimum',
      th: 'ปริมาณการสั่งซื้อสูงสุด',
      ms: 'Kuantiti Pesanan Maksimum',
      ar_eg: 'الحد الأقصى لكمية الطلب',
      uk: 'Максимальна Кількість Замовлення',
    },
    minimum_stock_qty_alert: {
      en: 'Minimum Stock QTY Alert',
      es: 'Alerta de Cantidad Mínima de Stock',
      fr: 'Alerte de Quantité Minimale de Stock',
      de: 'Mindestbestandswarnung',
      pt: 'Alerta de Quantidade Mínima de Estoque',
      pl: 'Alert Minimalnej Ilości Zapasów',
      nl: 'Minimumvoorraad Aantal Alert',
      el: 'Ειδοποίηση Ελάχιστης Ποσότητας Αποθέματος',
      cs: 'Upozornění na Minimální Množství Zásob',
      sv: 'Lagerkvantitetsvarning',
      hu: 'Minimális Készletmennyiség Figyelmeztetés',
      da: 'Minimum Lagerbeholdning Advarsel',
      fi: 'Minimi Varaston Määrän Hälytys',
      sk: 'Upozornenie na Minimálne Množstvo Skladu',
      bg: 'Предупреждение за Минимално Количество от Наличности',
      hr: 'Upozorenje o Minimalnoj Količini Zaliha',
      lt: 'Mažiausio Atsargų Kiekio Įspėjimas',
      lv: 'Minimālā Krājuma Daudzuma Brīdinājums',
      et: 'Minimaalne Varu Koguse Teavitus',
      sl: 'Opozorilo o Najmanjšem Količinskem Zalogu',
      ga: 'Foláireamh Cainníochta Íosta Stoc',
      mt: "Twissija ta' Kwantità Minima ta' Ħażna",
      cy: 'Rhybudd Qty Stoc Isafswm',
      ro: 'Alertă Cantitate Minimă Stoc',
      it: 'Avviso di Quantità Minima di Stock',
      zh_cn: '最低库存数量警报',
      hi: 'न्यूनतम स्टॉक मात्रा चेतावनी',
      ar: 'تنبيه الحد الأدنى من كمية المخزون',
      bn: 'ন্যূনতম স্টক পরিমাণ সতর্কতা',
      ru: 'Предупреждение о Минимальном Количестве Запасов',
      ja: '最小在庫量アラート',
      tr: 'Minimum Stok Miktarı Uyarısı',
      ko: '최소 재고 수량 경고',
      vi: 'Cảnh Báo Số Lượng Tồn Kho Tối Thiểu',
      id: 'Peringatan Kuantitas Stok Minimum',
      th: 'การแจ้งเตือนปริมาณสต็อกขั้นต่ำ',
      ms: 'Amaran Kuantiti Stok Minimum',
      ar_eg: 'تنبيه الحد الأدنى من كمية المخزون',
      uk: 'Сповіщення про Мінімальну Кількість Запасів',
    },
  },
  tabs: {
    general_info: {
      en: 'General Info',
      es: 'Información General',
      fr: 'Informations Générales',
      de: 'Allgemeine Informationen',
      pt: 'Informações Gerais',
      pl: 'Informacje Ogólne',
      nl: 'Algemene Informatie',
      el: 'Γενικές Πληροφορίες',
      cs: 'Obecné Informace',
      sv: 'Allmän Information',
      hu: 'Általános Információk',
      da: 'Generel Info',
      fi: 'Yleiset Tiedot',
      sk: 'Všeobecné Informácie',
      bg: 'Обща Информация',
      hr: 'Opće Informacije',
      lt: 'Bendra Informacija',
      lv: 'Vispārīga Informācija',
      et: 'Üldinfo',
      sl: 'Splošne Informacije',
      ga: 'Eolas Ginearálta',
      mt: 'Informazzjoni Ġenerali',
      cy: 'Gwybodaeth Gyffredinol',
      ro: 'Informații Generale',
      it: 'Informazioni Generali',
      zh_cn: '基本信息',
      hi: 'सामान्य जानकारी',
      ar: 'معلومات عامة',
      bn: 'সাধারণ তথ্য',
      ru: 'Общая Информация',
      ja: '一般情報',
      tr: 'Genel Bilgi',
      ko: '일반 정보',
      vi: 'Thông Tin Chung',
      id: 'Informasi Umum',
      th: 'ข้อมูลทั่วไป',
      ms: 'Maklumat Am',
      ar_eg: 'معلومات عامة',
      uk: 'Загальна Інформація',
    },
  },
  dialog: {
    title: {
      en: 'Item Details',
      es: 'Detalles del artículo',
      fr: "Détails de l'article",
      de: 'Artikeldetails',
      pt: 'Detalhes do item',
      pl: 'Szczegóły przedmiotu',
      nl: 'Artikelgegevens',
      el: 'Λεπτομέρειες αντικειμένου',
      cs: 'Podrobnosti o položce',
      sv: 'Artikelinformation',
      hu: 'Tétel részletei',
      da: 'Vareoplysninger',
      fi: 'Tuotetiedot',
      sk: 'Podrobnosti o položke',
      bg: 'Детайли за артикула',
      hr: 'Detalji stavke',
      lt: 'Prekės detalės',
      lv: 'Vienuma detaļas',
      et: 'Elemendi üksikasjad',
      sl: 'Podrobnosti o izdelku',
      ga: 'Sonraí Míre',
      mt: 'Dettalji tal-oġġett',
      cy: 'Manylion Eitem',
      ro: 'Detalii articol',
      it: "Dettagli dell'articolo",
      zh_cn: '商品详情',
      hi: 'आइटम विवरण',
      ar: 'تفاصيل العنصر',
      bn: 'আইটেমের বিবরণ',
      ru: 'Детали товара',
      ja: 'アイテムの詳細',
      tr: 'Ürün Detayları',
      ko: '항목 세부정보',
      vi: 'Chi tiết mặt hàng',
      id: 'Detail Item',
      th: 'รายละเอียดรายการ',
      ms: 'Butiran Item',
      ar_eg: 'تفاصيل العنصر',
      uk: 'Деталі товару',
    },
    modifier_no_data: {
      en: 'No modifier group has been linked',
      es: 'No se ha vinculado ningún grupo de modificadores',
      fr: 'Aucun groupe de modificateurs n’a été lié',
      de: 'Keine Modifikatorgruppe wurde verknüpft',
      pt: 'Nenhum grupo de modificadores foi vinculado',
      pl: 'Nie połączono żadnej grupy modyfikatorów',
      nl: 'Er is geen modifiergroep gekoppeld',
      el: 'Δεν έχει συνδεθεί καμία ομάδα τροποποιητών',
      cs: 'Žádná skupina modifikátorů nebyla připojena',
      sv: 'Ingen modifierargrupp har länkats',
      hu: 'Nincs módosító csoport hozzárendelve',
      da: 'Ingen modifieringsgruppe er blevet tilknyttet',
      fi: 'Yhtään muokkaajaryhmää ei ole liitetty',
      sk: 'Nebola pripojená žiadna skupina modifikátorov',
      bg: 'Не е свързана нито една група модификатори',
      hr: 'Nijedna grupa modifikatora nije povezana',
      lt: 'Nė viena modifikatorių grupė nėra susieta',
      lv: 'Nav saistīta neviena modifikatoru grupa',
      et: 'Ühtegi muutjarühma pole seotud',
      sl: 'Nobena skupina modifikatorjev ni povezana',
      ga: 'Níl aon ghrúpa modhnóirí ceangailte',
      mt: 'L-ebda grupp ta’ modifikaturi ma ġie marbut',
      cy: 'Nid yw unrhyw grŵp addasydd wedi’i gysylltu',
      ro: 'Niciun grup de modificatori nu a fost asociat',
      it: 'Nessun gruppo di modificatori è stato collegato',
      zh_cn: '尚未关联任何修改器组',
      hi: 'कोई मोडिफ़ायर समूह लिंक नहीं किया गया है',
      ar: 'لم يتم ربط أي مجموعة معدّلات',
      bn: 'কোনও পরিবর্তক গ্রুপ সংযুক্ত করা হয়নি',
      ru: 'Ни одна группа модификаторов не была привязана',
      ja: '修正グループがリンクされていません',
      tr: 'Herhangi bir değiştirici grubu bağlanmadı',
      ko: '수정자 그룹이 연결되지 않았습니다',
      vi: 'Chưa liên kết nhóm sửa đổi nào',
      id: 'Belum ada grup pengubah yang ditautkan',
      th: 'ยังไม่ได้เชื่อมโยงกลุ่มตัวปรับแต่ง',
      ms: 'Tiada kumpulan pengubah telah dipautkan',
      ar_eg: 'مافيش مجموعة معدّلات مرتبطة',
      uk: 'Жодна група модифікаторів не пов’язана',
    },
  },
  ingredients: {
    en: 'Ingredients',
    es: 'Ingredientes',
    fr: 'Ingrédients',
    de: 'Zutaten',
    pt: 'Ingredientes',
    pl: 'Składniki',
    nl: 'Ingrediënten',
    el: 'Συστατικά',
    cs: 'Ingredience',
    sv: 'Ingredienser',
    hu: 'Hozzávalók',
    da: 'Ingredienser',
    fi: 'Ainesosat',
    sk: 'Ingrediencie',
    bg: 'Съставки',
    hr: 'Sastojci',
    lt: 'Ingridientai',
    lv: 'Sastāvdaļas',
    et: 'Koostisosad',
    sl: 'Sestavine',
    ga: 'Comhábhair',
    mt: 'Ingredjenti',
    cy: 'Cynhwysion',
    ro: 'Ingrediente',
    it: 'Ingredienti',
    zh_cn: '配料',
    hi: 'सामग्री',
    ar: 'المكونات',
    bn: 'উপাদান',
    ru: 'Ингредиенты',
    ja: '材料',
    tr: 'Malzemeler',
    ko: '재료',
    vi: 'Nguyên liệu',
    id: 'Bahan-bahan',
    th: 'ส่วนผสม',
    ms: 'Bahan-bahan',
    ar_eg: 'مكونات',
    uk: 'Інгредієнти',
  },
  partner_id: {
    en: 'Partner ID',
    es: 'ID de Socio',
    fr: 'ID Partenaire',
    de: 'Partner-ID',
    pt: 'ID do Parceiro',
    pl: 'ID Partnera',
    nl: 'Partner-ID',
    el: 'Αναγνωριστικό Συνεργάτη',
    cs: 'ID Partnera',
    sv: 'Partner-ID',
    hu: 'Partnerazonosító',
    da: 'Partner-ID',
    fi: 'Kumppanin Tunnus',
    sk: 'ID Partnera',
    bg: 'Идентификационен Номер на Партньора',
    hr: 'ID Partnera',
    lt: 'Partnerio ID',
    lv: 'Partnera ID',
    et: 'Partneri ID',
    sl: 'ID Partnerja',
    ga: 'Aitheantas Comhpháirtí',
    mt: 'ID tas-Sieħeb',
    cy: 'Dynodydd Partner',
    ro: 'ID Partener',
    it: 'ID Partner',
    zh_cn: '合作伙伴ID',
    hi: 'पार्टनर आईडी',
    ar: 'معرف الشريك',
    bn: 'অংশীদার আইডি',
    ru: 'ID Партнёра',
    ja: 'パートナーID',
    tr: 'Ortak Kimliği',
    ko: '파트너 ID',
    vi: 'ID Đối Tác',
    id: 'ID Mitra',
    th: 'รหัสพันธมิตร',
    ms: 'ID Rakan Kongsi',
    ar_eg: 'معرف الشريك',
    uk: 'ID Партнера',
  },
  partner_name: {
    en: 'Partner Name',
    es: 'Nombre del Socio',
    fr: 'Nom du Partenaire',
    de: 'Partnername',
    pt: 'Nome do Parceiro',
    pl: 'Nazwa Partnera',
    nl: 'Partnernaam',
    el: 'Όνομα Συνεργάτη',
    cs: 'Název Partnera',
    sv: 'Partnernamn',
    hu: 'Partner Neve',
    da: 'Partnernavn',
    fi: 'Kumppanin Nimi',
    sk: 'Názov Partnera',
    bg: 'Име на Партньора',
    hr: 'Naziv Partnera',
    lt: 'Partnerio Pavadinimas',
    lv: 'Partnera Nosaukums',
    et: 'Partneri Nimi',
    sl: 'Ime Partnerja',
    ga: 'Ainm an Chomhpháirtí',
    mt: 'Isem is-Sieħeb',
    cy: 'Enw Partner',
    ro: 'Nume Partener',
    it: 'Nome del Partner',
    zh_cn: '合作伙伴名称',
    hi: 'पार्टनर का नाम',
    ar: 'اسم الشريك',
    bn: 'অংশীদারের নাম',
    ru: 'Имя Партнёра',
    ja: 'パートナー名',
    tr: 'Ortak Adı',
    ko: '파트너 이름',
    vi: 'Tên Đối Tác',
    id: 'Nama Mitra',
    th: 'ชื่อพันธมิตร',
    ms: 'Nama Rakan Kongsi',
    ar_eg: 'اسم الشريك',
    uk: 'Назва Партнера',
  },
  move_item_dialog: {
    title: {
      en: 'Move Item(s)',
      es: 'Mover artículo(s)',
      fr: "Déplacer l'article(s)",
      de: 'Artikel verschieben',
      pt: 'Mover item(ns)',
      pl: 'Przenieś przedmiot(y)',
      nl: 'Verplaats item(s)',
      el: 'Μετακίνηση αντικειμένου(ων)',
      cs: 'Přesunout položku(y)',
      sv: 'Flytta objekt(en)',
      hu: 'Tétel(ek) mozgatása',
      da: 'Flyt vare(r)',
      fi: 'Siirrä tuote(t)',
      sk: 'Presunúť položku(y)',
      bg: 'Премести артикул(и)',
      hr: 'Premjesti stavku(e)',
      lt: 'Perkelti prekę(-es)',
      lv: 'Pārvietot priekšmetu(s)',
      et: 'Liiguta üksus(i)',
      sl: 'Premakni izdelek(e)',
      ga: 'Bogear Mír(eanna)',
      mt: 'Mexxi oġġett(i)',
      cy: 'Symud Eitem(au)',
      ro: 'Mută articolul(ele)',
      it: 'Sposta articolo(i)',
      zh_cn: '移动项目',
      hi: 'मद(दें) ले जाएँ',
      ar: 'نقل العنصر(العناصر)',
      bn: 'আইটেম(গুলি) সরান',
      ru: 'Переместить элемент(ы)',
      ja: 'アイテムを移動',
      tr: 'Öğe(leri) Taşı',
      ko: '항목 이동',
      vi: 'Di chuyển mục',
      id: 'Pindahkan Item',
      th: 'ย้ายรายการ',
      ms: 'Pindahkan Item',
      ar_eg: 'نقل العنصر(العناصر)',
      uk: 'Перемістити предмет(и)',
    },
    dropdown: {
      placeholder: {
        en: 'Select Category',
        es: 'Seleccionar categoría',
        fr: 'Sélectionner une catégorie',
        de: 'Kategorie auswählen',
        pt: 'Selecionar categoria',
        pl: 'Wybierz kategorię',
        nl: 'Selecteer categorie',
        el: 'Επιλέξτε κατηγορία',
        cs: 'Vyberte kategorii',
        sv: 'Välj kategori',
        hu: 'Kategória kiválasztása',
        da: 'Vælg kategori',
        fi: 'Valitse kategoria',
        sk: 'Vybrať kategóriu',
        bg: 'Изберете категория',
        hr: 'Odaberite kategoriju',
        lt: 'Pasirinkite kategoriją',
        lv: 'Izvēlēties kategoriju',
        et: 'Vali kategooria',
        sl: 'Izberite kategorijo',
        ga: 'Roghnaigh Catagóir',
        mt: 'Agħżel Kategorija',
        cy: 'Dewis Categori',
        ro: 'Selectați categoria',
        it: 'Seleziona categoria',
        zh_cn: '选择类别',
        hi: 'श्रेणी चुनें',
        ar: 'اختر الفئة',
        bn: 'বিভাগ নির্বাচন করুন',
        ru: 'Выбрать категорию',
        ja: 'カテゴリーを選択',
        tr: 'Kategori Seç',
        ko: '카테고리 선택',
        vi: 'Chọn danh mục',
        id: 'Pilih Kategori',
        th: 'เลือกหมวดหมู่',
        ms: 'Pilih Kategori',
        ar_eg: 'اختر التصنيف',
        uk: 'Вибрати категорію',
      },
      label: {
        en: 'Move to Category',
        es: 'Mover a categoría',
        fr: 'Déplacer vers la catégorie',
        de: 'In Kategorie verschieben',
        pt: 'Mover para categoria',
        pl: 'Przenieś do kategorii',
        nl: 'Verplaatsen naar categorie',
        el: 'Μετακίνηση σε κατηγορία',
        cs: 'Přesunout do kategorie',
        sv: 'Flytta till kategori',
        hu: 'Áthelyezés kategóriába',
        da: 'Flyt til kategori',
        fi: 'Siirrä kategoriaan',
        sk: 'Presunúť do kategórie',
        bg: 'Преместване в категория',
        hr: 'Premjesti u kategoriju',
        lt: 'Perkelti į kategoriją',
        lv: 'Pārvietot uz kategoriju',
        et: 'Liiguta kategooriasse',
        sl: 'Premakni v kategorijo',
        ga: 'Bogear go Catagóir',
        mt: 'Mexxi għal Kategorija',
        cy: 'Symud i Gategori',
        ro: 'Mutare în categorie',
        it: 'Sposta in categoria',
        zh_cn: '移至类别',
        hi: 'श्रेणी में ले जाएँ',
        ar: 'النقل إلى الفئة',
        bn: 'বিভাগে সরান',
        ru: 'Переместить в категорию',
        ja: 'カテゴリーに移動',
        tr: 'Kategoriye Taşı',
        ko: '카테고리로 이동',
        vi: 'Chuyển đến danh mục',
        id: 'Pindah ke Kategori',
        th: 'ย้ายไปยังหมวดหมู่',
        ms: 'Pindah ke Kategori',
        ar_eg: 'الانتقال إلى الفئة',
        uk: 'Перемістити в категорію',
      },
    },
    selected: {
      en: 'Selected',
      es: 'Seleccionado',
      fr: 'Sélectionné',
      de: 'Ausgewählt',
      pt: 'Selecionado',
      pl: 'Wybrany',
      nl: 'Geselecteerd',
      el: 'Επιλεγμένο',
      cs: 'Vybráno',
      sv: 'Vald',
      hu: 'Kiválasztva',
      da: 'Valgt',
      fi: 'Valittu',
      sk: 'Vybrané',
      bg: 'Избрано',
      hr: 'Odabrano',
      lt: 'Pasirinktas',
      lv: 'Izvēlēts',
      et: 'Valitud',
      sl: 'Izbrano',
      ga: 'Roghnaithe',
      mt: 'Magħżul',
      cy: 'Dewiswyd',
      ro: 'Selectat',
      it: 'Selezionato',
      zh_cn: '已选择',
      hi: 'चयनित',
      ar: 'محدد',
      bn: 'নির্বাচিত',
      ru: 'Выбрано',
      ja: '選択済み',
      tr: 'Seçildi',
      ko: '선택됨',
      vi: 'Đã chọn',
      id: 'Terpilih',
      th: 'ที่เลือก',
      ms: 'Terpilih',
      ar_eg: 'مختار',
      uk: 'Вибрано',
    },
  },
  search_category: {
    en: 'Search category',
    es: 'Buscar categoría',
    fr: 'Rechercher une catégorie',
    de: 'Kategorie suchen',
    pt: 'Pesquisar categoria',
    pl: 'Szukaj kategorii',
    nl: 'Categorie zoeken',
    el: 'Αναζήτηση κατηγορίας',
    cs: 'Hledat kategorii',
    sv: 'Sök kategori',
    hu: 'Kategória keresése',
    da: 'Søg kategori',
    fi: 'Hae kategoriaa',
    sk: 'Hľadať kategóriu',
    bg: 'Търсене на категория',
    hr: 'Pretraži kategoriju',
    lt: 'Ieškoti kategorijos',
    lv: 'Meklēt kategoriju',
    et: 'Otsi kategooriat',
    sl: 'Išči kategorijo',
    ga: 'Cuardaigh catagóir',
    mt: 'Fittex kategorija',
    cy: 'Chwilio categori',
    ro: 'Caută categorie',
    it: 'Cerca categoria',
    zh_cn: '搜索类别',
    hi: 'श्रेणी खोजें',
    ar: 'البحث في الفئة',
    bn: 'বিভাগ খুঁজুন',
    ru: 'Поиск категории',
    ja: 'カテゴリを検索',
    tr: 'Kategori ara',
    ko: '카테고리 검색',
    vi: 'Tìm kiếm danh mục',
    id: 'Cari kategori',
    th: 'ค้นหาหมวดหมู่',
    ms: 'Cari kategori',
    ar_eg: 'ابحث في الفئة',
    uk: 'Пошук категорії',
  },

  bulk_edit_items: {
    en: 'Bulk Edit Items',
    es: 'Editar artículos en masa',
    fr: 'Modifier des articles en masse',
    de: 'Artikel in großen Mengen bearbeiten',
    pt: 'Editar itens em massa',
    pl: 'Edycja zbiorcza pozycji',
    nl: 'Items in bulk bewerken',
    el: 'Μαζική επεξεργασία ειδών',
    cs: 'Hromadná úprava položek',
    sv: 'Massredigera artiklar',
    hu: 'Tételek tömeges szerkesztése',
    da: 'Rediger varer i bulk',
    fi: 'Muokkaa tuotteita massana',
    sk: 'Hromadná úprava položiek',
    bg: 'Масово редактиране на артикули',
    hr: 'Masovno uređivanje stavki',
    lt: 'Masinis prekių redagavimas',
    lv: 'Vienumu masveida rediģēšana',
    et: 'Hulgiüksuste redigeerimine',
    sl: 'Množično urejanje elementov',
    ga: 'Eagarthóireacht mórchóir ar mhíreanna',
    mt: 'Editjar oġġetti bl-ingrossa',
    cy: 'Golygu eitemau mewn swmp',
    ro: 'Editare articole în masă',
    it: 'Modifica articoli in blocco',
    zh_cn: '批量编辑商品',
    hi: 'आइटम का बल्क संपादन',
    ar: 'تعديل العناصر بالجملة',
    bn: 'আইটেমগুলো একসাথে সম্পাদনা করুন',
    ru: 'Массовое редактирование товаров',
    ja: '商品の一括編集',
    tr: 'Toplu Ürün Düzenleme',
    ko: '항목 일괄 편집',
    vi: 'Chỉnh sửa hàng loạt mục',
    id: 'Edit item secara massal',
    th: 'แก้ไขรายการแบบกลุ่ม',
    ms: 'Sunting item secara pukal',
    ar_eg: 'تعديل العناصر بشكل جماعي',
    uk: 'Масове редагування товарів',
  },

  bulk_save: {
    en: 'Bulk Save',
    es: 'Guardar en masa',
    fr: 'Enregistrer en masse',
    de: 'Massenhaft speichern',
    pt: 'Salvar em massa',
    pl: 'Zapisz zbiorczo',
    nl: 'In bulk opslaan',
    el: 'Μαζική αποθήκευση',
    cs: 'Hromadné uložení',
    sv: 'Masspara',
    hu: 'Tömeges mentés',
    da: 'Gem i bulk',
    fi: 'Tallenna massana',
    sk: 'Hromadné uloženie',
    bg: 'Масово запазване',
    hr: 'Masovno spremanje',
    lt: 'Masinis išsaugojimas',
    lv: 'Masveida saglabāšana',
    et: 'Hulgisalvestus',
    sl: 'Množično shranjevanje',
    ga: 'Sábháil mórchóir',
    mt: 'Issejvja bl-ingrossa',
    cy: 'Cadw mewn swmp',
    ro: 'Salvare în masă',
    it: 'Salvataggio in blocco',
    zh_cn: '批量保存',
    hi: 'बल्क सेव',
    ar: 'حفظ جماعي',
    bn: 'একসাথে সংরক্ষণ করুন',
    ru: 'Массовое сохранение',
    ja: '一括保存',
    tr: 'Toplu Kaydet',
    ko: '일괄 저장',
    vi: 'Lưu hàng loạt',
    id: 'Simpan massal',
    th: 'บันทึกแบบกลุ่ม',
    ms: 'Simpan secara pukal',
    ar_eg: 'حفظ جماعي',
    uk: 'Масове збереження',
  },
  bulk_item_edit: {
    en: 'Bulk Item Edit',
    es: 'Edición masiva de artículos',
    fr: 'Modification en masse des articles',
    de: 'Massenbearbeitung von Artikeln',
    pt: 'Edição em massa de itens',
    pl: 'Masowa edycja pozycji',
    nl: 'Bulk bewerking van items',
    el: 'Μαζική επεξεργασία ειδών',
    cs: 'Hromadná úprava položek',
    sv: 'Massredigering av artiklar',
    hu: 'Tételek tömeges szerkesztése',
    da: 'Masse redigering af varer',
    fi: 'Tuotteiden massamuokkaus',
    sk: 'Hromadná úprava položiek',
    bg: 'Масово редактиране на артикули',
    hr: 'Masovno uređivanje stavki',
    lt: 'Masinis prekių redagavimas',
    lv: 'Vienumu masveida rediģēšana',
    et: 'Üksuste massmuutmine',
    sl: 'Množično urejanje elementov',
    ga: 'Eagarthóireacht mhórchóir ar mhíreanna',
    mt: 'Editjar oġġetti bl-ingrossa',
    cy: 'Golygu eitemau mewn swmp',
    ro: 'Editare în masă a articolelor',
    it: 'Modifica in massa degli articoli',
    zh_cn: '批量编辑商品',
    hi: 'आइटम का बल्क संपादन',
    ar: 'تعديل العناصر بالجملة',
    bn: 'আইটেমের ব্যাচ এডিট',
    ru: 'Массовое редактирование товаров',
    ja: '商品の一括編集',
    tr: 'Toplu Ürün Düzenleme',
    ko: '항목 일괄 편집',
    vi: 'Chỉnh sửa hàng loạt mục',
    id: 'Edit item secara massal',
    th: 'แก้ไขรายการแบบกลุ่ม',
    ms: 'Sunting item secara pukal',
    ar_eg: 'تعديل العناصر بشكل جماعي',
    uk: 'Масове редагування товарів',
  },
  multiple_sales_taxes_edit_warning: {
    en: 'Tax cannot be bulk edited for items with variable tax.',
    es: 'El impuesto no se puede editar de forma masiva para artículos con impuesto variable.',
    fr: 'La taxe ne peut pas être modifiée en masse pour les articles à taxe variable.',
    de: 'Für Artikel mit variabler Steuer kann die Steuer nicht massenbearbeitet werden.',
    pt: 'O imposto não pode ser editado em massa para itens com imposto variável.',
    pl: 'Podatku nie można edytować masowo dla pozycji z podatkiem zmiennym.',
    nl: 'Belasting kan niet in bulk worden bewerkt voor items met variabele belasting.',
    el: 'Ο φόρος δεν μπορεί να τροποποιηθεί μαζικά για είδη με μεταβλητό φόρο.',
    cs: 'U položek s proměnlivou daní nelze daň hromadně upravit.',
    sv: 'Skatt kan inte massredigeras för artiklar med varierande skatt.',
    hu: 'A változó adóval rendelkező tételek esetében az adó nem szerkeszthető tömegesen.',
    da: 'Skat kan ikke masseredigeres for varer med variabel skat.',
    fi: 'Veroa ei voi massamuokata tuotteille, joilla on vaihteleva vero.',
    sk: 'Pri položkách s premenlivou daňou nemožno daň hromadne upraviť.',
    bg: 'Данъкът не може да бъде редактиран масово за артикули с променлив данък.',
    hr: 'Porez se ne može masovno uređivati za stavke s promjenjivim porezom.',
    lt: 'Prekėms su kintamu mokesčiu mokesčio negalima redaguoti masiškai.',
    lv: 'Vienumiem ar mainīgu nodokli nodokli nevar rediģēt masveidā.',
    et: 'Muutuva maksuga üksuste puhul ei saa maksu massmuutmisega redigeerida.',
    sl: 'Za postavke s spremenljivim davkom davka ni mogoče množično urejati.',
    ga: 'Ní féidir cáin a chur in eagar go mórchóireach ar mhíreanna a bhfuil cáin athraitheach acu.',
    mt: "It-taxxa ma tistax tiġi editjata bl-ingrossa għal oġġetti b'taxxa varjabbli.",
    cy: 'Ni ellir golygu treth mewn swmp ar gyfer eitemau â threth amrywiol.',
    ro: 'Taxa nu poate fi editată în masă pentru articolele cu taxă variabilă.',
    it: 'Non è possibile modificare in massa la tassa per gli articoli con tassa variabile.',
    zh_cn: '含可变税率的商品无法批量编辑税率。',
    hi: 'परिवर्तनीय कर वाले आइटम के लिए कर को बल्क में संपादित नहीं किया जा सकता।',
    ar: 'لا يمكن تعديل الضريبة بشكل جماعي للعناصر ذات الضريبة المتغيرة.',
    bn: 'পরিবর্তনশীল ট্যাক্স সহ আইটেমের জন্য ট্যাক্স ব্যাচ আকারে সম্পাদনা করা যাবে না।',
    ru: 'Налог нельзя массово редактировать для товаров с переменным налогом.',
    ja: '可変税率の商品では、税率を一括編集できません。',
    tr: 'Değişken vergiye sahip ürünler için vergi toplu olarak düzenlenemez.',
    ko: '가변 세율이 적용된 항목은 세금을 일괄 편집할 수 없습니다.',
    vi: 'Không thể chỉnh sửa hàng loạt thuế cho các mặt hàng có thuế biến đổi.',
    id: 'Pajak tidak dapat diedit secara massal untuk barang dengan pajak variabel.',
    th: 'ไม่สามารถแก้ไขภาษีแบบกลุ่มสำหรับรายการที่มีภาษีผันแปรได้',
    ms: 'Cukai tidak boleh disunting secara pukal untuk item dengan cukai berubah-ubah.',
    ar_eg: 'مايمكنش تعديل الضريبة بشكل جماعي للعناصر اللي عندها ضريبة متغيرة.',
    uk: 'Податок не можна масово редагувати для товарів зі змінним податком.',
  },
  item_table: {
    no_active_tax: {
      en: 'No Active Tax',
      es: 'Sin Impuesto Activo',
      fr: 'Aucune Taxe Active',
      de: 'Keine Aktive Steuer',
      pt: 'Sem Imposto Ativo',
      pl: 'Brak Aktywnego Podatku',
      nl: 'Geen Actieve Belasting',
      el: 'Χωρίς Ενεργό Φόρο',
      cs: 'Žádná Aktivní Daň',
      sv: 'Ingen Aktiv Skatt',
      hu: 'Nincs Aktív Adó',
      da: 'Ingen Aktiv Skat',
      fi: 'Ei Aktiivista Veroa',
      sk: 'Žiadna Aktívna Daň',
      bg: 'Няма Активен Данък',
      hr: 'Nema Aktivnog Poreza',
      lt: 'Nėra Aktyvaus Mokesčio',
      lv: 'Nav Aktīva Nodokļa',
      et: 'Aktiivset Maksu Pole',
      sl: 'Ni Aktivnega Davka',
      ga: 'Gan Cáin Ghníomhach',
      mt: 'L-Ebda Taxxa Attiva',
      cy: 'Dim Treth Weithredol',
      ro: 'Fără Taxă Activă',
      it: 'Nessuna Tassa Attiva',
      zh_cn: '无有效税率',
      hi: 'कोई सक्रिय कर नहीं',
      ar: 'لا توجد ضريبة نشطة',
      bn: 'কোনো সক্রিয় ট্যাক্স নেই',
      ru: 'Нет Активного Налога',
      ja: '有効な税なし',
      tr: 'Aktif Vergi Yok',
      ko: '활성 세금 없음',
      vi: 'Không Có Thuế Hoạt Động',
      id: 'Tidak Ada Pajak Aktif',
      th: 'ไม่มีภาษีที่ใช้งาน',
      ms: 'Tiada Cukai Aktif',
      ar_eg: 'مفيش ضريبة مفعلة',
      uk: 'Немає Активного Податку',
    },
  },
}
export default translate
